import constants from '../constants.js';

const CommonGroupSpacer = {
  displayAs: constants.DISPLAY_AS.SPACER
};

const DebtorProductType = {
  displayName: 'Product Type',
  dataAt: 'DebtorProducts.$debtProductItem.Type',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'DebtorProductOptions',
  isConditionalProperty: true
}

const DebtorProductMobileSetting1 = {
  displayName: 'Bookings by roles enabled',
  dataAt: 'DebtorProducts.$debtProductItem.BookingsByRolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only the following listed roles are allowed to make bookings'
}

const DebtorProductMobileSetting2 = {
  displayName: 'Proof of life enabled',
  dataAt: 'DebtorProducts.$debtProductItem.ProofOfLifeEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: 'Enable proof of life'
}

const DebtorProductMobileSetting3 = {
  displayName: 'Proof of life email notifications',
  dataAt: 'DebtorProducts.$debtProductItem.ProofOfLifeEmailRecipients',
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: 'The list of recipients you would like to send proof of life emails to'
}

const DebtorProductEnableSetting = {
  displayName: 'Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.Enabled',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: 'Enable product for this debtor'
}

const DebtorProductCTMApproveSetting1 = {
  displayName: 'Multi Pax Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.MultiPaxRolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these role types will be able to add more than 1 traveller to CTM Approve intent requests'
};

const DebtorProductCTMPortalPowerBISetting1 = {
  displayName: 'Sustainability Reporting Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.PowerBIFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the Sustainability Report graph'
};

const DebtorProductCTMPortalPowerBISetting2 = {
  displayName: 'Data Hub Role',
  dataAt: 'DebtorProducts.$debtProductItem.PowerBIFeature.DataHubRole',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Role must match Data Hub Role from Power BI Team'
};

const DebtorProductCTMPortalRiskHubRoles = {
  displayName: 'Risk Hub Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.RiskHubFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the Risk Hub application'
};

const DebtorProductCTMPortalScoutRoles = {
  displayName: 'Scout Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.ScoutFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only roles Enabled will be able to see Scout (instant chat)'
};

const DebtorProductCTMPortalScoutUrl = {
  displayName: 'Custom URL',
  dataAt: 'DebtorProducts.$debtProductItem.ScoutFeature.ScoutRasaUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Server URL to be provided by Scout Team'
};

const DebtorProductCTMPortalSetting23 = {
  displayName: 'Ticket Credit Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.TicketCreditFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the Ticket Credit application'
};

const DebtorProductCTMPortalSetting22 = {
  displayName: 'Cytric SSO URL',
  dataAt: 'DebtorProducts.$debtProductItem.CytricFeature.CytricUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Cytric Sso URL'
};

const DebtorProductCTMPortalSetting21 = {
  displayName: 'Cytric Client ID Password',
  dataAt: 'DebtorProducts.$debtProductItem.CytricFeature.CytricClientPassword',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Cytric Client ID Password'
};

const DebtorProductCTMPortalSetting20 = {
  displayName: 'Cytric Client ID Name',
  dataAt: 'DebtorProducts.$debtProductItem.CytricFeature.CytricClientId',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Cytric Client ID Name'
};

const DebtorProductCTMPortalSetting19 = {
  displayName: 'Cytric Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.CytricFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the Cytric application tile'
};

const DebtorProductCTMPortalProfileManagementSetting2 = {
  displayName: 'Custom URL',
  dataAt: 'DebtorProducts.$debtProductItem.QbtProfileManagementFeature.CustomUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: ''
};

const DebtorProductCTMPortalProfileManagementSetting1 = {
  displayName: 'Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.QbtProfileManagementFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to view the tile'
};

const DebtorProductCTMQuoteRequestFormSettings2 = {
  displayName: 'Custom URL',
  dataAt: 'DebtorProducts.$debtProductItem.QuoteRequestFeature.CustomUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: ''
};

const DebtorProductCTMQuoteRequestFormSettings1 = {
  displayName: 'Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.QuoteRequestFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to view the tile'
};

const DebtorProductCTMPortalSetting18 = {
  displayName: 'Profile Tool',
  dataAt: 'DebtorProducts.$debtProductItem.ProfileFeature.ProfileTool',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'ProfileTools',
  helpText: 'This is the tool that will open from the Profiles application tile'
};

const DebtorProductCTMPortalSetting17 = {
  displayName: 'Profile Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.ProfileFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the profile application tile'
};

const DebtorProductCTMPortalSetting16 = {
  displayName: 'Serko SSO Url',
  dataAt: 'DebtorProducts.$debtProductItem.SerkoFeature.SerkoSsoUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Serko Sso Url'
};

const DebtorProductCTMPortalSetting15 = {
  displayName: 'Serko SSO Key',
  dataAt: 'DebtorProducts.$debtProductItem.SerkoFeature.SerkoSsoKey',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Serko Sso Key'
};

const DebtorProductCTMPortalSetting14 = {
  displayName: 'Serko Unique Id',
  dataAt: 'DebtorProducts.$debtProductItem.SerkoFeature.SerkoUniqueId',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Serko Unique Id'
};

const DebtorProductCTMPortalSetting13 = {
  displayName: 'Serko Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.SerkoFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the Serko application tile.'
};

const DebtorProductCTMPortalSetting12 = {
  displayName: 'Etm Custom Url',
  dataAt: 'DebtorProducts.$debtProductItem.EtmFeature.CustomUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Events air custom url'
};

const DebtorProductCTMPortalSetting11 = {
  displayName: 'Etm Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.EtmFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the ETM application tile'
};

const DebtorProductCTMPortalKnowledgeCentreSetting1 = {
  displayName: 'Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.KnowledgeCentreFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the tile'
};

const DebtorProductCTMPortalKnowledgeCentreSetting2 = {
  displayName: 'Custom Url',
  dataAt: 'DebtorProducts.$debtProductItem.KnowledgeCentreFeature.CustomUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: ''
};

const DebtorProductCTMPortalSetting10 = {
  displayName: 'Travel Tracker Sms Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.TravelTrackerFeature.SmsEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: 'Enabled SMS notifications for travel tracker feature'
};

const DebtorProductCTMPortalSetting9 = {
  displayName: 'Travel Tracker Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.TravelTrackerFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the Travel Tracker feature'
};

const DebtorProductCTMPortalSetting8 = {
  displayName: 'Tramada Invoice Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.TramadaFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the Invoice application tile'
};

const DebtorProductCTMPortalSetting7 = {
  displayName: 'Lightning Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.LightningFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the Lightning Book application tile'
};

const DebtorProductCTMPortalSetting6 = {
  displayName: 'Fare Forecaster Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.FareForecasterFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the Fare Forecaster Feature'
};

const DebtorProductCTMPortalTravellerTripsSetting = {
  displayAs: constants.DISPLAY_AS.MULTI_SELECT_GROUP,
  parent: {
    displayName: 'Traveller Trips Roles Enabled',
    dataAt: 'DebtorProducts.$debtProductItem.TravellerTripsFeature.RolesEnabled',
    displayAs: constants.DISPLAY_AS.MULTI_SELECT,
    optionsAt: 'UserRoles',
    helpText: 'Only these roles will be able to see the Traveller Trips data.'
  },
  child: {
    displayName: 'Wellbeing Score Enabled',
    dataAt: 'DebtorProducts.$debtProductItem.WellBeingScoreFeature.RolesEnabled',
    displayAs: constants.DISPLAY_AS.MULTI_SELECT,
    optionsAt: 'UserRoles',
    helpText: '<strong>Only these roles will be able to see the Wellbeing Scores</strong>'
  }
};

const DebtorProductCTMPortalCTMDataSetting1 = {
  displayName: 'Ctm Data Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.CtmDataFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the Ctm Data application tile'
};

const DebtorProductCTMPortalCTMDataSetting2 = {
  displayName: 'Custom URL',
  dataAt: 'DebtorProducts.$debtProductItem.CtmDataFeature.CustomUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorProductCTMPortalSetting4 = {
  displayName: 'Ctm Approve Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.CtmApproveFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the Ctm Approve application tile'
};

const DebtorProductCTMPortalSetting3 = {
  displayName: 'Concur Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.ConcurFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the Concur application tile'
};

const DebtorProductCTMPortalSetting2 = {
  displayName: 'Enable Advertising feature',
  dataAt: 'DebtorProducts.$debtProductItem.AdvertisingFeature.Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: 'Enable advertising feature for this debtor'
};

const DebtorProductCTMPortalBeamerEnabled = {
  displayName: 'Enable Beamer',
  dataAt: 'DebtorProducts.$debtProductItem.BeamerFeature.Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: 'Enable Beamer feature for this debtor'
};

const DebtorProductCTMPortalSettingRoles = {
  displayName: 'People Page Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.PeopleFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the People page'
}

const DebtorProductCTMPortalVisaSettingsRoles = {
  displayName: 'Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.VisaFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the tile'
}

const DebtorProductCTMPortalVisaSettingsUrl = {
  displayName: 'Custom Url',
  dataAt: 'DebtorProducts.$debtProductItem.VisaFeature.CustomUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: ''
};

const DebtorProductCTMPortalVisaSettingsGroup = {
  displayName: 'Visa Information Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalVisaSettingsRoles,
    DebtorProductCTMPortalVisaSettingsUrl,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalTrackRequestSettingsRoles = {
  displayName: 'Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.TrackRequestFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the tile'
}

const DebtorProductCTMPortalTrackRequestSettingsUrl = {
  displayName: 'Custom Url',
  dataAt: 'DebtorProducts.$debtProductItem.TrackRequestFeature.CustomUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: ''
};

const DebtorProductCTMPortalTrackRequestSettingsGroup = {
  displayName: 'Track Requests and Issues Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalTrackRequestSettingsRoles,
    DebtorProductCTMPortalTrackRequestSettingsUrl,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalCharterRequestSettingsRoles = {
  displayName: 'Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.CharterRequestFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the tile'
}

const DebtorProductCTMPortalCharterRequestSettingsUrl = {
  displayName: 'Custom Url',
  dataAt: 'DebtorProducts.$debtProductItem.CharterRequestFeature.CustomUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: ''
};

const DebtorProductCTMPortalGroupBookingRequestFormSettingsRoles = {
  displayName: 'Roles Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.GroupBookingRequestFeature.RolesEnabled',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'UserRoles',
  helpText: 'Only these roles will be able to see the tile'
}

const DebtorProductCTMPortalGroupBookingRequestFormSettingsUrl = {
  displayName: 'Custom Url',
  dataAt: 'DebtorProducts.$debtProductItem.GroupBookingRequestFeature.CustomUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: ''
};

const DebtorProductCTMPortalCharterRequestSettingsGroup = {
  displayName: 'Charter Booking Request',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalCharterRequestSettingsRoles,
    DebtorProductCTMPortalCharterRequestSettingsUrl,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalGroupBookingRequestFormSettingsGroup = {
  displayName: 'Group Booking Request Form',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalGroupBookingRequestFormSettingsRoles,
    DebtorProductCTMPortalGroupBookingRequestFormSettingsUrl,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalPeoplePageSettingsGroup = {
  displayName: 'People Page Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalSettingRoles,
    CommonGroupSpacer]
};

const DebtorProductCTMPortalProfileSettingsGroup = {
  displayName: 'Profile Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalSetting17,
    DebtorProductCTMPortalSetting18,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalProfileManagementSettingsGroup = {
  displayName: 'Profile Management QBT Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalProfileManagementSetting1,
    DebtorProductCTMPortalProfileManagementSetting2,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMQuoteRequestFormSettingsGroup = {
  displayName: 'Quote Request Form Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMQuoteRequestFormSettings1,
    DebtorProductCTMQuoteRequestFormSettings2,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalAdvertisingSettingsGroup = {
  displayName: 'Advertising Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalSetting2,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalBeamerSettingsGroup = {
  displayName: 'Beamer Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalBeamerEnabled,
    CommonGroupSpacer],
  helpText: 'Noticeboard for Internal alerts - CTM News Feed and Notification Centre'
};

const DebtorProductCTMPortalCtmConcurSettingsGroup = {
  displayName: 'Concur Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalSetting3,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalCtmApproveSettingsGroup = {
  displayName: 'CTM Approve Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalSetting4,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalCtmDataSettingsGroup = {
  displayName: 'CTM Data Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalCTMDataSetting1,
    DebtorProductCTMPortalCTMDataSetting2,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalPowerBISettingsGroup = {
  displayName: 'Sustainability Reporting Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalPowerBISetting1,
    DebtorProductCTMPortalPowerBISetting2,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalFareForecasterSettingsGroup = {
  displayName: 'Fare Forecaster Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalSetting6,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalTravellerTripsSettingsGroup = {
  displayName: 'Traveller Trips & Wellbeing Score Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalTravellerTripsSetting,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalLightningSettingsGroup = {
  displayName: 'Lightning Book Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalSetting7,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalTramadaSettingsGroup = {
  displayName: 'Tramada Invoice Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalSetting8,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalTravelTrackerSettingsGroup = {
  displayName: 'Travel Tracker Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalSetting9,
    DebtorProductCTMPortalSetting10,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalEtmSettingsGroup = {
  displayName: 'ETM Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalSetting11,
    DebtorProductCTMPortalSetting12,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalKnowledgeCentreSettingsGroup = {
  displayName: 'Knowledge Centre',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalKnowledgeCentreSetting1,
    DebtorProductCTMPortalKnowledgeCentreSetting2,
    CommonGroupSpacer
  ]
};

const DebtorProductCTMPortalSerkoSettingsGroup = {
  displayName: 'Serko Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalSetting13,
    DebtorProductCTMPortalSetting14,
    DebtorProductCTMPortalSetting15,
    DebtorProductCTMPortalSetting16,
    CommonGroupSpacer]
};

const DebtorProductCTMPortalCytricSettingsGroup = {
  displayName: 'Cytric Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalSetting19,
    DebtorProductCTMPortalSetting20,
    DebtorProductCTMPortalSetting21,
    DebtorProductCTMPortalSetting22,
    CommonGroupSpacer]
};

const DebtorProductCTMPortalRiskHubSettingsGroup = {
  displayName: 'Risk Hub Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalRiskHubRoles,
    CommonGroupSpacer]
};

const DebtorProductCTMPortalScoutSettingsGroup = {
  displayName: 'Scout Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalScoutRoles,
    DebtorProductCTMPortalScoutUrl,
    CommonGroupSpacer]
};

const DebtorProductCTMPortalTicketCreditSettingsGroup = {
  displayName: 'Ticket Credit Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorProductCTMPortalSetting23,
    CommonGroupSpacer]
};

const DebtorProductCTMMobileSettings = {
  displayName: 'Item',
  dataAt: 'DebtorProducts.$debtProductItem',
  children: [
    DebtorProductEnableSetting,
    DebtorProductMobileSetting1,
    DebtorProductMobileSetting2,
    DebtorProductMobileSetting3
  ],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debtProductItem',
  canDelete: true,
}

const DebtorProductLightningSettings = {
  displayName: 'Item',
  dataAt: 'DebtorProducts.$debtProductItem',
  children: [DebtorProductEnableSetting],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debtProductItem',
  canDelete: true,
}

const DebtorProductCTMPortalSettings = {
  displayName: 'Item',
  dataAt: 'DebtorProducts.$debtProductItem',
  children: [
    DebtorProductEnableSetting,
    DebtorProductCTMPortalAdvertisingSettingsGroup,
    DebtorProductCTMPortalBeamerSettingsGroup,
    DebtorProductCTMPortalCtmApproveSettingsGroup,
    DebtorProductCTMPortalCtmDataSettingsGroup,
    DebtorProductCTMPortalPowerBISettingsGroup,
    DebtorProductCTMPortalFareForecasterSettingsGroup,
    DebtorProductCTMPortalTravellerTripsSettingsGroup,
    DebtorProductCTMPortalLightningSettingsGroup,
    DebtorProductCTMPortalTramadaSettingsGroup,
    DebtorProductCTMPortalProfileSettingsGroup,
    DebtorProductCTMPortalProfileManagementSettingsGroup,
    DebtorProductCTMQuoteRequestFormSettingsGroup,
    DebtorProductCTMPortalTravelTrackerSettingsGroup,
    DebtorProductCTMPortalPeoplePageSettingsGroup,
    DebtorProductCTMPortalTicketCreditSettingsGroup,
    DebtorProductCTMPortalVisaSettingsGroup,
    DebtorProductCTMPortalTrackRequestSettingsGroup,
    DebtorProductCTMPortalCharterRequestSettingsGroup,
    DebtorProductCTMPortalGroupBookingRequestFormSettingsGroup,
    DebtorProductCTMPortalRiskHubSettingsGroup,
    DebtorProductCTMPortalScoutSettingsGroup,
    DebtorProductCTMPortalEtmSettingsGroup,
    DebtorProductCTMPortalKnowledgeCentreSettingsGroup,
    DebtorProductCTMPortalCtmConcurSettingsGroup,
    DebtorProductCTMPortalSerkoSettingsGroup,
    DebtorProductCTMPortalCytricSettingsGroup
  ],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debtProductItem',
  canDelete: true,
}

const DebtorProductCTMApproveSettings = {
  displayName: 'Item',
  dataAt: 'DebtorProducts.$debtProductItem',
  children: [DebtorProductEnableSetting, CommonGroupSpacer, DebtorProductCTMApproveSetting1],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debtProductItem',
  canDelete: true,
}

const DebtorProductHotelReviewSetting2 = {
  displayName: 'Enable Auto-Approve',
  dataAt: 'DebtorProducts.$debtProductItem.AutoApproveEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: 'Enable Auto-approve hotel reviews'
};

const DebtorProductHotelReviewSetting3 = {
  displayName: 'Administrator Email Recipients',
  dataAt: 'DebtorProducts.$debtProductItem.AdministratorEmailRecipients',
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: 'The list of recipients you would like to send hotel review approval emails to',
  inputType: 'email',
  validateEmail: true
}

const DebtorProductHotelReviewSetting4ItemSetting3 = {
  displayName: 'ExternalId',
  dataAt: 'DebtorProducts.$debtProductItem.DisabledTravellers.$dsbldTrvlrHotelReviewItem.ExternalId',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Traveller external Id'
}

const DebtorProductHotelReviewSetting4ItemSetting2 = {
  displayName: 'Email',
  dataAt: 'DebtorProducts.$debtProductItem.DisabledTravellers.$dsbldTrvlrHotelReviewItem.Email',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true,
  helpText: 'Traveller email address (required)',
  inputType: 'email',
  validateEmail: true
}

const DebtorProductHotelReviewSetting4ItemSetting1 = {
  displayName: 'Name',
  dataAt: 'DebtorProducts.$debtProductItem.DisabledTravellers.$dsbldTrvlrHotelReviewItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Traveller full name'
}

const DebtorProductHotelReviewSetting4Item = {
  displayName: 'Item',
  dataAt: 'DebtorProducts.$debtProductItem.DisabledTravellers.$dsbldTrvlrHotelReviewItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    DebtorProductHotelReviewSetting4ItemSetting1,
    DebtorProductHotelReviewSetting4ItemSetting2
  ],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'dsbldTrvlrHotelReviewItem',
  canDelete: true
};

const DebtorProductHotelReviewSetting4 = {
  displayName: 'Notifications for travellers disabled',
  dataAt: 'DebtorProducts.$debtProductItem.DisabledTravellers',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  helpText: 'Travellers',
  gridItem: DebtorProductHotelReviewSetting4Item,
  gridCols:
    [{ name: 'Name', key: 'Name' },
    { name: 'Email', key: 'Email' },
    { name: 'Email Enabled', key: 'EmailEnabled' }],
  excelExport: {
    fileName: 'Hotel Review - travellers',
    arrayParentRef: {
      name: 'Name',
      dataAt: 'Name'
    },
    cols: [
      {
        name: 'Name',
        dataAt: 'Name'
      },
      {
        name: 'Email',
        dataAt: 'Email'
      },
      {
        name: 'Mobile',
        dataAt: 'Mobile'
      },
      {
        name: 'Email Enabled',
        dataAt: 'EmailEnabled',
        isBoolean: true,
      },
      {
        name: 'Sms Enabled',
        dataAt: 'SmsEnabled',
        isBoolean: true,
      },
      {
        name: 'Enabled',
        dataAt: 'Enabled',
        isBoolean: true,
      }
    ]
  }
};

const DebtorProductHotelReviewSettings = {
  displayName: 'Item',
  dataAt: 'DebtorProducts.$debtProductItem',
  children: [DebtorProductEnableSetting, DebtorProductHotelReviewSetting2, DebtorProductHotelReviewSetting3, DebtorProductHotelReviewSetting4],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debtProductItem',
  canDelete: true,
}

const DebtorProductTripsGlobalAPI = {
  displayName: 'Global Api Enabled',
  dataAt: 'DebtorProducts.$debtProductItem.GlobalApiEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: `Enable Global API`
}

const DebtorProductTripsSettings = {
  displayName: 'Item',
  dataAt: 'DebtorProducts.$debtProductItem',
  children: [DebtorProductEnableSetting, DebtorProductTripsGlobalAPI],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debtProductItem',
  canDelete: true,
}

const DebtorProductRideShareSettings = {
  displayName: 'Item',
  dataAt: 'DebtorProducts.$debtProductItem',
  children: [DebtorProductEnableSetting],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debtProductItem',
  canDelete: true,
}

const DebtorProductRiskSetting5ItemSetting5 = {
  displayName: 'Disable Sms',
  dataAt: 'DebtorProducts.$debtProductItem.DisabledTravellers.$dsbldTrvlrItem.SmsDisabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: 'Disable sms notifcations for this traveller'
}

const DebtorProductRiskSetting5ItemSetting4 = {
  displayName: 'Disable Email',
  dataAt: 'DebtorProducts.$debtProductItem.DisabledTravellers.$dsbldTrvlrItem.EmailDisabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: 'Disable email notifcations for this traveller'
}

const DebtorProductRiskSetting5ItemSetting3 = {
  displayName: 'Mobile',
  dataAt: 'DebtorProducts.$debtProductItem.DisabledTravellers.$dsbldTrvlrItem.Mobile',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Traveller mobile, include country dialing code e.g. 61415000000 (required to disable sms)'
}

const DebtorProductRiskSetting5ItemSetting2 = {
  displayName: 'Email',
  dataAt: 'DebtorProducts.$debtProductItem.DisabledTravellers.$dsbldTrvlrItem.Email',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Traveller email address (required to disable email)'
}

const DebtorProductRiskSetting5ItemSetting1 = {
  displayName: 'Name',
  dataAt: 'DebtorProducts.$debtProductItem.DisabledTravellers.$dsbldTrvlrItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'Traveller full name'
}

const DebtorProductRiskSetting5Item = {
  displayName: 'Item',
  dataAt: 'DebtorProducts.$debtProductItem.DisabledTravellers.$dsbldTrvlrItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    DebtorProductRiskSetting5ItemSetting1,
    DebtorProductRiskSetting5ItemSetting2,
    DebtorProductRiskSetting5ItemSetting3,
    DebtorProductRiskSetting5ItemSetting4,
    DebtorProductRiskSetting5ItemSetting5
  ],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'dsbldTrvlrItem',
  canDelete: true
};

const DebtorProductRiskSetting5 = {
  displayName: 'Disabled Travellers for notifications',
  dataAt: 'DebtorProducts.$debtProductItem.DisabledTravellers',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  helpText: 'List of travellers that would not like type(s) of notifications sent',
  gridItem: DebtorProductRiskSetting5Item,
  gridCols:
    [{ name: 'Name', key: 'Name' },
    { name: 'Email', key: 'Email' },
    { name: 'Mobile', key: 'Mobile' }],
  excelExport: {
    fileName: 'Risk - Disabled travellers',
    arrayParentRef: {
      name: 'Name',
      dataAt: 'Name'
    },
    cols: [
      {
        name: 'Name',
        dataAt: 'Name'
      },
      {
        name: 'Email',
        dataAt: 'Email'
      },
      {
        name: 'Mobile',
        dataAt: 'Mobile'
      },
      {
        name: 'Email Disabled',
        dataAt: 'EmailDisabled',
        isBoolean: true,
      },
      {
        name: 'Sms Disabled',
        dataAt: 'SmsDisabled',
        isBoolean: true,
      }
    ]
  }
};

const DebtorProductRiskSetting4 = {
  displayName: 'Minimum Risk Rating',
  dataAt: 'DebtorProducts.$debtProductItem.MinimumRiskRating',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'MinimumRiskRatings',
  defaultOption: 'Moderate',
  helpText: 'Minimum risk rating'
}

const DebtorProductRiskSetting3 = {
  displayName: 'Group Email Recipients',
  dataAt: 'DebtorProducts.$debtProductItem.GroupEmailRecipients',
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: 'The list of recipients you would like to send risk emails to'
}

const DebtorProductRiskSetting2 = {
  displayName: 'Enable Sms',
  dataAt: 'DebtorProducts.$debtProductItem.SmsEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: 'Enable sms notifications'
};

const DebtorProductRiskSetting1 = {
  displayName: 'Enable Emails',
  dataAt: 'DebtorProducts.$debtProductItem.EmailEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: 'Enable email notifications'
};

const DebtorProductRiskSettings = {
  displayName: 'Item',
  dataAt: 'DebtorProducts.$debtProductItem',
  children: [DebtorProductEnableSetting, DebtorProductRiskSetting1, DebtorProductRiskSetting2, DebtorProductRiskSetting3, DebtorProductRiskSetting4, DebtorProductRiskSetting5],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debtProductItem',
  canDelete: true,
}

const DebtorProductsItem = {
  displayName: 'Item',
  dataAt: 'DebtorProducts.$debtProductItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorProductType],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debtProductItem',
  canDelete: true,
  hasConditionalChildren: true,
  conditionalProperty: DebtorProductType,
  conditionalChildren: [
    {
      Type: constants.PRODUCT.CTMMOBILE,
      Value: DebtorProductCTMMobileSettings
    },
    {
      Type: constants.PRODUCT.LIGHTNINGBOOK,
      Value: DebtorProductLightningSettings
    },
    {
      Type: constants.PRODUCT.CTMPORTAL,
      Value: DebtorProductCTMPortalSettings
    },
    {
      Type: constants.PRODUCT.CTMAPPROVE,
      Value: DebtorProductCTMApproveSettings
    },
    {
      Type: constants.PRODUCT.HOTELREVIEW,
      Value: DebtorProductHotelReviewSettings
    },
    {
      Type: constants.PRODUCT.RISK,
      Value: DebtorProductRiskSettings
    },
    {
      Type: constants.PRODUCT.RIDESHARE,
      Value: DebtorProductRideShareSettings
    },
    {
      Type: constants.PRODUCT.TRIPS,
      Value: DebtorProductTripsSettings
    },
  ],
  ODataArgs: '?$expand=DebtorProducts',
}

const DebtorProducts = {
  displayName: 'Debtor Products',
  dataAt: 'DebtorProducts',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: false,
  canAddNew: true,
  gridItem: DebtorProductsItem,
  gridCols: [
    {
      name: 'Product',
      key: 'Type'
    },
    {
      name: 'Enabled',
      key: 'Enabled'
    }
  ],
  ODataArgs: '?$expand=DebtorProducts',
};

const AgencyServiceFeeRemarkTitle = {
  displayName: 'Title',
  dataAt: 'AgencyServiceFeeRemarks.$agencySvcFeeRmkItem.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: false
};

const AgencyServiceFeeRemarkValue = {
  displayName: 'Service Fee Remark',
  dataAt: 'AgencyServiceFeeRemarks.$agencySvcFeeRmkItem.Value',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const AgencyServiceFeeRemarkCountries = {
  displayName: 'Countries',
  dataAt: 'AgencyServiceFeeRemarks.$agencySvcFeeRmkItem.Countries',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const AgencyServiceFeeRemarkSegmentTypes = {
  displayName: 'Segment Types',
  dataAt: 'AgencyServiceFeeRemarks.$agencySvcFeeRmkItem.SegmentTypes',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'SegmentTypes'
}

const AgencyServiceFeeRemarksItem = {
  displayName: 'Item',
  dataAt: 'AgencyServiceFeeRemarks.$agencySvcFeeRmkItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AgencyServiceFeeRemarkTitle, AgencyServiceFeeRemarkSegmentTypes, AgencyServiceFeeRemarkCountries, AgencyServiceFeeRemarkValue],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'agencySvcFeeRmkItem',
  canDelete: true
}

const AgencyServiceFeeRemarks = {
  displayName: 'Service Fee Remarks',
  dataAt: 'AgencyServiceFeeRemarks',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AgencyServiceFeeRemarksItem,
  gridCols: [
    { name: 'Title', key: 'Title' },
    { name: 'Segment Types', key: 'SegmentTypes' },
    { name: 'Countries', key: 'Countries' },
    { name: 'Service Fee Remark', key: 'Value' }
  ]
};

const CancellationRemarks = {
  displayName: 'Cancellation Remarks',
  dataAt: 'CancellationRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const SegmentCancellationRemarks = {
  displayName: 'Segment Cancellation Remarks',
  dataAt: 'SegmentCancellationRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const UserManagementSystem = {
  displayName: 'Enable User Management System',
  dataAt: 'UsersConfig.EnableUserManagementSystem',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: ""
}

const UseCustomerIdAsLoginUsername = {
  displayName: 'Use Customer ID as Login Username',
  dataAt: 'UsersConfig.UseCustomerId',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: ""
}

const UsersMigrate = {
  displayName: 'Migrate to User Management System',
  dataAt: 'UsersConfig.MigrateToUserManagementSystem',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: ""
}

const UsersWelcomeEmails = {
  displayName: 'Send Welcome Emails to Users',
  dataAt: 'UsersConfig.WelcomeEmailsEnabled',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: "When switched on, all new users configured below will be sent a welcome email upon initial creation. Existing users will be unaffected by this setting."
}

const UsersPasswordExpiry = {
  displayName: 'Password Expires in (default 90 days):',
  dataAt: 'UsersConfig.PasswordExpiresIn',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: 1,
  max: 90,
  helpText: "Number of days before users are forced to change their password."
}

const SeletedProfilesForUserCreationItem = {
  displayName: 'Item',
  dataAt: 'UsersConfig.SelectedProfilesForUserCreation.$selProfileItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    {
      displayName: 'Full Name',
      dataAt: 'UsersConfig.SelectedProfilesForUserCreation.$selProfileItem.FullName',
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
      helpText: 'Profile full name'
    },
    {
      displayName: 'Email',
      dataAt: 'UsersConfig.SelectedProfilesForUserCreation.$selProfileItem.Email',
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
      helpText: 'Profile email'
    },
    {
      displayName: 'Roles',
      dataAt: 'UsersConfig.SelectedProfilesForUserCreation.$selProfileItem.Roles',
      displayAs: constants.DISPLAY_AS.MULTI_SELECT,
      optionsAt: 'UserRoles',
      helpText: 'Profile roles(s) to match on'
    }
  ],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'selProfileItem',
  canDelete: true
};

const SeletedProfilesForUserCreation = {
  displayName: 'Sync selected profiles only',
  dataAt: 'UsersConfig.SelectedProfilesForUserCreation',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  helpText: 'Only profiles with the "role" in their travel profile whose email address is entered below will be created as a CTM user.<br>(<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Note changing this setting will trigger a reprocessing of data.)',
  gridItem: SeletedProfilesForUserCreationItem,
  gridCols:
    [{ name: 'FullName', key: 'FullName' },
    { name: 'Email', key: 'Email' },
    { name: 'Roles', key: 'Roles' }],
  excelExport: {
    fileName: 'Selected Profiles User Creation',
    arrayParentRef: {
      name: 'FullName',
      dataAt: 'FullName'
    },
    cols: [
      {
        name: 'FullName',
        dataAt: 'FullName'
      },
      {
        name: 'Email',
        dataAt: 'Email'
      },
      {
        name: 'Roles',
        dataAt: 'Roles',
        isArray: true
      }
    ]
  }
};

const TravelArrangerAutoUserCreation = {
  displayName: 'Sync all Travel Arranger Profiles',
  dataAt: 'UsersConfig.TravelArrangerAutoUserCreationEnabled',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: "All users with the <b>Travel Arranger</b> role in their travel profile will be created as a CTM user. <i class='fa fa-exclamation-triangle' aria-hidden='true'></i> Note changing this setting will trigger a reprocessing of data."
}

const TravellerAutoUserCreation = {
  displayName: 'Sync all Traveller Profiles',
  dataAt: 'UsersConfig.TravellerAutoUserCreationEnabled',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: "All users with the <b>Traveller</b> role in their travel profile will be created as a CTM user. <i class='fa fa-exclamation-triangle' aria-hidden='true'></i> Note changing this setting will trigger a reprocessing of data."
}

const UsersPanelSpacer = {
  displayAs: constants.DISPLAY_AS.SPACER
};

const ResetTravellersWatermark = {
  displayAs: constants.DISPLAY_AS.CONFIRM_BUTTON,
  buttonText: 'Reset travellers watermark',
  confirmMessage: 'Are you sure you want to reset travellers watermark?',
  enabledIf: 'UsersConfig.TravellerAutoUserCreationEnabled',
  endpoint: '/api/resetdebtor/Travellers?debtorIdentifier=',
  helpText: 'Sync all traveller profiles must be enabled and saved before you are able to reset the watermark'
}

const ResetTravelArrangersWatermark = {
  displayAs: constants.DISPLAY_AS.CONFIRM_BUTTON,
  buttonText: 'Reset travel arrangers watermark',
  confirmMessage: 'Are you sure you want do reset the travel arrangers watermark?',
  enabledIf: 'UsersConfig.TravelArrangerAutoUserCreationEnabled',
  endpoint: '/api/resetdebtor/TravelArrangers?debtorIdentifier=',
  helpText: 'Sync all travel arranger profiles must be enabled and saved before you are able to reset the watermark'
}


const ResetSelectedProfilesWatermark = {
  displayAs: constants.DISPLAY_AS.CONFIRM_BUTTON,
  buttonText: 'Reset selected profiles watermark',
  confirmMessage: 'Are you sure you want do reset the selected profiles watermark?',
  endpoint: '/api/resetdebtor/SyncSelectedProfiles?debtorIdentifier=',
  helpText: 'All profiles listed and saved in the table will be reset'
}

const UsersPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Users',
  children: [UsersMigrate, UserManagementSystem, UseCustomerIdAsLoginUsername, UsersPanelSpacer, UsersWelcomeEmails, UsersPanelSpacer, UsersPasswordExpiry, UsersPanelSpacer, TravellerAutoUserCreation, ResetTravellersWatermark, TravelArrangerAutoUserCreation, ResetTravelArrangersWatermark, SeletedProfilesForUserCreation, ResetSelectedProfilesWatermark]
};

const DebtorProductsPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Products',
  children: [DebtorProducts]
};

const AzureTenantIds = {
  displayName: 'Azure Tenant Id\'s',
  dataAt: 'AuthenticationConfig.AzureTenantIds',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const SamlConnectionNames = {
  displayName: 'SAML Connection Names',
  dataAt: 'AuthenticationConfig.SamlConnectionNames',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const PaymentConfigurationsPaymentTypesConfigurationsSuppliersSettings = {
  displayName: 'Settings',
  dataAt: 'PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Suppliers.$payConSupItem.Settings',
  displayAs: constants.DISPLAY_AS.KEY_VALUE_PAIRS,
  keyOptions: 'SuppliersSettingsOptions'
};

const PaymentConfigurationsPaymentTypesConfigurationsSuppliersName = {
  displayName: 'Name',
  dataAt: 'PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Suppliers.$payConSupItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const PaymentConfigurationsPaymentTypesConfigurationsSuppliersItem = {
  displayName: 'Suppliers',
  dataAt: 'PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Suppliers.$payConSupItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [PaymentConfigurationsPaymentTypesConfigurationsSuppliersName, PaymentConfigurationsPaymentTypesConfigurationsSuppliersSettings],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'payConSupItem',
  canDelete: true
};

const DebtorGdsMiQuestionsItemQuestionsItemAnswerFormat = {
  displayName: 'Answer Format',
  dataAt: 'Gds.$GdsItem.MiQuestions.$MiItem.Questions.$question.AnswerFormat',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorGdsMiQuestionsItemQuestionsItemQuestion = {
  displayName: 'Question',
  dataAt: 'Gds.$GdsItem.MiQuestions.$MiItem.Questions.$question.Question',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const PaymentConfigurationsPaymentTypesConfigurationsSuppliers = {
  displayName: 'Suppliers',
  dataAt: 'PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Suppliers',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: PaymentConfigurationsPaymentTypesConfigurationsSuppliersItem,
  gridCols: [{ name: 'Name', key: 'Name' }]
};

const PaymentConfigurationsPaymentTypesConfigurationsSector = {
  displayName: 'Sector',
  dataAt: 'PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Sector',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'SectorTypes'
};

const ItineraryPoliciesCarPolicyRestrictionPolicyType = {
  displayName: 'Policy Type',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.PolicyType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'CarPolicyTypes'
};

const ItineraryPoliciesCarPolicyRestrictionMaximumDailyRate = {
  displayName: 'Maximum Daily Rate',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.MaximumDailyRate',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesCarPolicyRestrictionSipps = {
  displayName: 'Sipps',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.Sipps',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesCarPolicyRestrictionCountryCodes = {
  displayName: 'Country Codes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.CountryCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesCarPolicyRestrictionLocationCodes = {
  displayName: 'Location Codes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.LocationCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesCarPolicyRestrictionSuppliers = {
  displayName: 'Suppliers',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.Suppliers',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesCarBreakPolicyRulesCountries = {
  displayName: 'Countries',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.BreakPolicyRules.$carPolBreakPolRulesItem.Countries',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const ItineraryPoliciesCarBreakPolicyRulesBreakPolicyWindow = {
  displayName: 'Break Policy Window (hours)',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.BreakPolicyRules.$carPolBreakPolRulesItem.BreakPolicyWindow',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesCarPolicyPreferredSipps = {
  displayName: 'Sipps',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem.Sipps',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesCarPolicyPreferredCountryCodes = {
  displayName: 'Country Codes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem.CountryCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesCarPolicyPreferredLocationCodes = {
  displayName: 'Location Codes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem.LocationCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesCarPolicyPreferredSuppliers = {
  displayName: 'Suppliers',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem.Suppliers',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesCarPolicyExceptionSettingsSipps = {
  displayName: 'Sipps',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.Sipps',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesCarPolicyExceptionSettingsSuppliers = {
  displayName: 'Supplier Codes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.Suppliers',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesCarPolicyExceptionSettingsCountryCodes = {
  displayName: 'Country Codes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.CountryCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesCarPolicyExceptionSettingsLocationCodes = {
  displayName: 'Location Codes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.LocationCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesCarPolicyExceptionSettingsMaximumDailyRate = {
  displayName: 'Maximum Daily Rate',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.MaximumDailyRate',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesCarPolicyExceptionsCountries = {
  displayName: 'Countries',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions.$carPolExcItem.Countries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesCarPolicyExceptionsCode = {
  displayName: 'Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions.$carPolExcItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesCarPolicyExceptionsTitle = {
  displayName: 'Title',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions.$carPolExcItem.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesCarPoliciesAllowDeliveryAndCollection = {
  displayName: 'Allow Delivery And Collection',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.AllowDeliveryAndCollection',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const ItineraryPoliciesCarPoliciesAllowMineSpecVehicles = {
  displayName: 'Mine Spec Vehicles',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.AllowMineSpecVehicles',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const ItineraryPoliciesCarPoliciesCostCentres = {
  displayName: 'Debtor Cost Centres',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.CostCentres',
  displayAs: constants.DISPLAY_AS.O_DATA_INDEX_MULTI_SELECT,
  windowVar: 'travellersSearch',
  index: 'costcentres',
  suggester: 'costcentresg',
  apiVersion: '2016-09-01',
  searchId: 'Name',
  searchFields: ['CostCentreCode', 'CostCentreName'],
  valueField: 'CostCentreCode',
  titleField: 'CostCentreName'
};

const ItineraryPoliciesCarPoliciesDepartments = {
  displayName: 'Debtor Departments',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Departments',
  displayAs: constants.DISPLAY_AS.O_DATA_INDEX_MULTI_SELECT,
  windowVar: 'travellersSearch',
  index: 'departments',
  suggester: 'departmentsg',
  apiVersion: '2016-09-01',
  searchId: 'Name',
  searchFields: ['DepartmentName', 'DepartmentCode'],
  valueField: 'DepartmentCode',
  titleField: 'DepartmentName'
};

const ItineraryPoliciesCarPoliciesRate = {
  displayName: 'Car Policies Rate',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Rate',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesCarPoliciesCorporateCode = {
  displayName: 'Car Policies Corporate Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.CorporateCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesCarPoliciesSupplierTitle = {
  displayName: 'Car Policies Supplier Title',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Supplier.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesCarPoliciesSupplierCode = {
  displayName: 'Car Policies Supplier Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Supplier.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesCarPoliciesName = {
  displayName: 'Car Policy Name',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesHotelPolicyExceptionSettingsLatitude = {
  displayName: 'Latitude',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Latitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: -9999999999,
  max: 9999999999
};

const ItineraryPoliciesHotelPolicyExceptionSettingsLongitude = {
  displayName: 'Longitude',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Longitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: -9999999999,
  max: 9999999999
};

const ItineraryPoliciesHotelPolicyExceptionSettingsRadius = {
  displayName: 'Radius',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Radius',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const HotelConfigurationIsImperialSystem = {
  displayName: 'Imperial System',
  dataAt: 'IsImperialSystem',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const ItineraryPoliciesHotelPolicyExceptionSettingsLatLong = {
  displayName: 'Address Search',
  displayAs: constants.DISPLAY_AS.LAT_LONG_MAP_SEARCH,
  latField: ItineraryPoliciesHotelPolicyExceptionSettingsLatitude,
  longField: ItineraryPoliciesHotelPolicyExceptionSettingsLongitude,
  radiusField: ItineraryPoliciesHotelPolicyExceptionSettingsRadius,
  IsImperialSystemField: HotelConfigurationIsImperialSystem
};

const ItineraryPoliciesHotelPolicyExceptionSettingsMaximumDailyRate = {
  displayName: 'Maximum Daily Rate',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.MaximumDailyRate',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesHotelPolicyExceptionSettingsCountryCode = {
  displayName: 'Country Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.CountryCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesHotelPolicyExceptionSettingsLocationCode = {
  displayName: 'Location Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.LocationCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesHotelPolicyExceptionSettingsName = {
  displayName: 'Name',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesHotelPolicyExceptionsCountries = {
  displayName: 'Countries',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions.$hotelPolExcItem.Countries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesHotelPolicyExceptionsCode = {
  displayName: 'Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions.$hotelPolExcItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesHotelPolicyExceptionsTitle = {
  displayName: 'Title',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions.$hotelPolExcItem.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesHotelBreakPolicyRulesCountries = {
  displayName: 'Countries',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.BreakPolicyRules.$ItinPolBreakPolRulesItem.Countries',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const ItineraryPoliciesHotelBreakPolicyRulesBreakPolicyWindow = {
  displayName: 'Break Policy Window (hours)',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.BreakPolicyRules.$ItinPolBreakPolRulesItem.BreakPolicyWindow',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesHotelPoliciesRadius = {
  displayName: 'Policy Radius',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Radius',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesHotelPoliciesLongitude = {
  displayName: 'Policy Longitude',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Longitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: -9999999999,
  max: 9999999999
};

const ItineraryPoliciesHotelPoliciesLatitude = {
  displayName: 'Policy Latitude',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Latitude',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: -9999999999,
  max: 9999999999
};

const ItineraryPoliciesHotelPoliciesHotels = {
  displayName: 'Non-GDS hotel IDs',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Hotels',
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: 'Add any Events Air or Expedia hotel ids here to make them preferred.'
};

const ItineraryPoliciesSabreCslPoliciesHotels = {
  displayName: 'SabreCsl Hotels',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.SabreCslHotels',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesHotelPoliciesLatLong = {
  displayName: 'Address Search',
  displayAs: constants.DISPLAY_AS.LAT_LONG_MAP_SEARCH,
  latField: ItineraryPoliciesHotelPoliciesLatitude,
  longField: ItineraryPoliciesHotelPoliciesLongitude,
  radiusField: ItineraryPoliciesHotelPoliciesRadius,
  IsImperialSystemField: HotelConfigurationIsImperialSystem,
  additionalPlots: ItineraryPoliciesHotelPoliciesHotels
};

const ItineraryPoliciesHotelPoliciesExcludedHotels = {
  displayName: 'Excluded Hotels',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.ExcludedHotels',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesHotelPoliciesExcludedChainCodes = {
  displayName: 'Excluded Chains',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.ExcludedChainCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesHotelPoliciesMinimumHotelRating = {
  displayName: 'Minimum Hotel Rating',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.MinimumHotelRating',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: 0,
  max: 4
};

const ItineraryPoliciesHotelPoliciesPostCode = {
  displayName: 'Post Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.PostCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesHotelPoliciesCountryCode = {
  displayName: 'Hotel Policies Country Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.CountryCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesHotelPoliciesLocationCode = {
  displayName: 'Hotel Policies Location Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.LocationCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesHotelPoliciesChainCodes = {
  displayName: 'Hotel Policies Chain Codes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.ChainCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesHotelPoliciesRateMax = {
  displayName: 'Hotel Policies Maximum Rate',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Rate.Max',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesHotelPoliciesRateMin = {
  displayName: 'Hotel Policies Minimum Rate',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Rate.Min',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesHotelPoliciesPolicyName = {
  displayName: 'Hotel Policy Name',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.PolicyName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesRailPolicyExceptionsCountries = {
  displayName: 'Countries',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions.$railPolExcItem.Countries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesRailPolicyExceptionsCode = {
  displayName: 'Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions.$railPolExcItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesRailPolicyExceptionsTitle = {
  displayName: 'Title',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions.$railPolExcItem.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesRailPoliciesGroupTypes = {
  displayName: 'Group Types',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem.GroupTypes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesRailPoliciesPolicyType = {
  displayName: 'Policy Type',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem.PolicyType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'PolicyTypes'
};

const ItineraryPoliciesRailPoliciesSuppliers = {
  displayName: 'Suppliers',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem.Suppliers',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesFlightPolicyExceptionSettingsBenchmarkMostDirect = {
  displayName: 'Benchmark Most Direct',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.BenchmarkMostDirect',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const ItineraryPoliciesFlightPolicyExceptionSettingsFlightType = {
  displayName: 'Flight Type',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.FlightType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'FlightTypes'
};

const ItineraryPoliciesFlightPolicyExceptionSettingsLowestFareGroupType = {
  displayName: 'Lowest Fare Group Type',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.LowestFareGroupType',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightPolicyExceptionSettingsPriceTolerance = {
  displayName: 'Price Tolerance',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.PriceTolerance',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesFlightPolicyExceptionSettingsGroupTypes = {
  displayName: 'Group Types',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.GroupTypes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesFlightPolicyExceptionSettingsDurationTo = {
  displayName: 'Duration To (minutes)',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.DurationTo',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesFlightPolicyExceptionSettingsDurationFrom = {
  displayName: 'Duration From (minutes)',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.DurationFrom',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesFlightPolicyExceptionSettingsDestinationCountryCode = {
  displayName: 'Destination Country Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.DestinationCountryCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightPolicyExceptionSettingsOriginCountryCode = {
  displayName: 'Origin Country Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.OriginCountryCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightBreakPolicyRulesOrigins = {
  displayName: 'Origins',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.BreakPolicyRules.$flightBreakPolRulItem.Origins',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const ItineraryPoliciesFlightBreakPolicyRulesDestinations = {
  displayName: 'Destinations',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.BreakPolicyRules.$flightBreakPolRulItem.Destinations',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const ItineraryPoliciesFlightBreakPolicyRulesBreakPolicyWindow = {
  displayName: 'Break Policy Window (hours)',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.BreakPolicyRules.$flightBreakPolRulItem.BreakPolicyWindow',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesFlightBestFareOfFlightCarriers = {
  displayName: 'Carriers',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.BestFareOfFlights.$flightBestFareItem.Carriers',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesFlightBestFareOfFlightCountries = {
  displayName: 'Countries',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.BestFareOfFlights.$flightBestFareItem.Countries',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const ItineraryPoliciesFlightBestFareOfFlightApply = {
  displayName: 'Tick to apply BFOF to results. Untick to exclude BFOF from results',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.BestFareOfFlights.$flightBestFareItem.Apply',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  notNullable: true
};

const ItineraryPoliciesFlightPolicyExceptionsCountries = {
  displayName: 'Countries',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions.$flightPolExcItem.Countries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesFlightPolicyExceptionsCode = {
  displayName: 'Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions.$flightPolExcItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightPolicyExceptionsTitle = {
  displayName: 'Title',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions.$flightPolExcItem.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightPoliciesPolicyType = {
  displayName: 'Policy Type',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.PolicyType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'PolicyTypes'
};

const ItineraryPoliciesFlightPoliciesFareClasses = {
  displayName: 'Fare Classes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.FareClasses',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesFlightPoliciesGroupTypes = {
  displayName: 'Group Types',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.GroupTypes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesFlightPoliciesDurationTo = {
  displayName: 'Duration To (minutes)',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DurationTo',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesFlightPoliciesDurationFrom = {
  displayName: 'Duration From (minutes)',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DurationFrom',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesFlightPoliciesDurationType = {
  displayName: 'Duration Type',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DurationType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'DurationTypeOptions'
};

const ItineraryPoliciesFlightPoliciesDestinationCountryCode = {
  displayName: 'Destination Country Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DestinationCountryCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightPoliciesOriginCountryCode = {
  displayName: 'Origin Country Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.OriginCountryCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightPoliciesOriginLocationCode = {
  displayName: 'Origin Location Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.OriginLocationCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightPoliciesDestinationLocationCode = {
  displayName: 'Destination Location Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DestinationLocationCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightPoliciesBookingCodes = {
  displayName: 'Booking Codes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.BookingCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesFlightPoliciesCarrier = {
  displayName: 'Carrier',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.Carrier',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightBenchmarksExceptionsOriginLocationCode = {
  displayName: 'Origin Location Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions.$flightBenchExcItem.OriginLocationCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightBenchmarksExceptionsDestinationLocationCode = {
  displayName: 'Destination Location Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions.$flightBenchExcItem.DestinationLocationCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightBenchmarksExceptionsCarrier = {
  displayName: 'Carrier',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions.$flightBenchExcItem.Carrier',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesFlightBenchmarksPoliciesBookingCodes = {
  displayName: 'Booking Codes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Policies.$flightBenchPolItem.BookingCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesFlightBenchmarksPoliciesCarrier = {
  displayName: 'Carrier',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Policies.$flightBenchPolItem.Carrier',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesItemsTitle = {
  displayName: 'Title',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Items.$ItinPolItemIndex.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesItemsCode = {
  displayName: 'Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Items.$ItinPolItemIndex.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorGdsMiQuestionsItemQuestionsItem = {
  displayName: 'Question',
  dataAt: 'Gds.$GdsItem.MiQuestions.$MiItem.Questions.$question',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorGdsMiQuestionsItemQuestionsItemQuestion, DebtorGdsMiQuestionsItemQuestionsItemAnswerFormat],
  endpoint: 'Debtors',
  removeParamId: 'question',
  canDelete: true
};

const PaymentTypesConfigurationsItem = {
  displayName: 'Configuration',
  dataAt: 'PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [PaymentConfigurationsPaymentTypesConfigurationsSector, PaymentConfigurationsPaymentTypesConfigurationsSuppliers],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'payTypeConItem',
  canDelete: true
};

const ItineraryPoliciesCarBreakPolicyRulesItem = {
  displayName: 'Item',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.BreakPolicyRules.$carPolBreakPolRulesItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesCarBreakPolicyRulesCountries,
    ItineraryPoliciesCarBreakPolicyRulesBreakPolicyWindow
  ],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'carPolBreakPolRulesItem',
  canDelete: true
};

const ItineraryPoliciesCarPolicyRestrictionItem = {
  displayName: 'Policy Restriction',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesCarPolicyRestrictionSuppliers, ItineraryPoliciesCarPolicyRestrictionLocationCodes, ItineraryPoliciesCarPolicyRestrictionCountryCodes, ItineraryPoliciesCarPolicyRestrictionSipps, ItineraryPoliciesCarPolicyRestrictionMaximumDailyRate, ItineraryPoliciesCarPolicyRestrictionPolicyType],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'carPolRestrictedItem',
  canDelete: true
};

const ItineraryPoliciesCarPolicyPreferredItem = {
  displayName: 'Policy Preferred',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesCarPolicyPreferredSuppliers, ItineraryPoliciesCarPolicyPreferredLocationCodes, ItineraryPoliciesCarPolicyPreferredCountryCodes, ItineraryPoliciesCarPolicyPreferredSipps],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'carPolPrefItem',
  canDelete: true
};

const ItineraryPoliciesCarPolicyExceptionSettingsItem = {
  displayName: 'Policy Exception Settings',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesCarPolicyExceptionSettingsMaximumDailyRate, ItineraryPoliciesCarPolicyExceptionSettingsLocationCodes, ItineraryPoliciesCarPolicyExceptionSettingsCountryCodes, ItineraryPoliciesCarPolicyExceptionSettingsSuppliers, ItineraryPoliciesCarPolicyExceptionSettingsSipps],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'carPolExcSetItem',
  canDelete: true
};

const ItineraryPoliciesCarPolicyExceptionsItem = {
  displayName: 'Item',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions.$carPolExcItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesCarPolicyExceptionsTitle, ItineraryPoliciesCarPolicyExceptionsCode, ItineraryPoliciesCarPolicyExceptionsCountries],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'carPolExcItem',
  canDelete: true
};

const ItineraryPoliciesCarPoliciesItem = {
  displayName: 'Car Policy',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesCarPoliciesName, ItineraryPoliciesCarPoliciesSupplierCode, ItineraryPoliciesCarPoliciesSupplierTitle, ItineraryPoliciesCarPoliciesCorporateCode, ItineraryPoliciesCarPoliciesRate, ItineraryPoliciesCarPoliciesDepartments, ItineraryPoliciesCarPoliciesCostCentres, ItineraryPoliciesCarPoliciesAllowDeliveryAndCollection, ItineraryPoliciesCarPoliciesAllowMineSpecVehicles],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'carPolItem',
  canDelete: true
};

const ItineraryPoliciesHotelPolicyExceptionSettingsItem = {
  displayName: 'Policy Exception Settings',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesHotelPolicyExceptionSettingsName, ItineraryPoliciesHotelPolicyExceptionSettingsLocationCode, ItineraryPoliciesHotelPolicyExceptionSettingsCountryCode, ItineraryPoliciesHotelPolicyExceptionSettingsMaximumDailyRate, ItineraryPoliciesHotelPolicyExceptionSettingsRadius, ItineraryPoliciesHotelPolicyExceptionSettingsLatitude, ItineraryPoliciesHotelPolicyExceptionSettingsLongitude, ItineraryPoliciesHotelPolicyExceptionSettingsLatLong],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'ItinPolExcSetItem',
  canDelete: true
};

const ItineraryPoliciesHotelBreakPolicyRulesItem = {
  displayName: 'Item',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.BreakPolicyRules.$ItinPolBreakPolRulesItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesHotelBreakPolicyRulesCountries,
    ItineraryPoliciesHotelBreakPolicyRulesBreakPolicyWindow
  ],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'ItinPolBreakPolRulesItem',
  canDelete: true
};

const ItineraryPoliciesHotelPolicyExceptionsItem = {
  displayName: 'Item',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions.$hotelPolExcItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesHotelPolicyExceptionsTitle, ItineraryPoliciesHotelPolicyExceptionsCode, ItineraryPoliciesHotelPolicyExceptionsCountries],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'hotelPolExcItem',
  canDelete: true
};

const ItineraryPoliciesHotelPoliciesItem = {
  displayName: 'Hotel Policy',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesHotelPoliciesPolicyName, ItineraryPoliciesHotelPoliciesHotels, ItineraryPoliciesSabreCslPoliciesHotels, ItineraryPoliciesHotelPoliciesRateMin, ItineraryPoliciesHotelPoliciesRateMax, ItineraryPoliciesHotelPoliciesChainCodes, ItineraryPoliciesHotelPoliciesLocationCode, ItineraryPoliciesHotelPoliciesCountryCode, ItineraryPoliciesHotelPoliciesPostCode, ItineraryPoliciesHotelPoliciesMinimumHotelRating, ItineraryPoliciesHotelPoliciesExcludedChainCodes, ItineraryPoliciesHotelPoliciesExcludedHotels, ItineraryPoliciesHotelPoliciesRadius, ItineraryPoliciesHotelPoliciesLatitude, ItineraryPoliciesHotelPoliciesLongitude, ItineraryPoliciesHotelPoliciesLatLong],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'hotelPolItem',
  canDelete: true
};

const ItineraryPoliciesRailPolicyExceptionsItem = {
  displayName: 'Item',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions.$railPolExcItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesRailPolicyExceptionsTitle, ItineraryPoliciesRailPolicyExceptionsCode, ItineraryPoliciesRailPolicyExceptionsCountries],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'railPolExcItem',
  canDelete: true
};

const ItineraryPoliciesRailPoliciesItem = {
  displayName: 'Policy',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesRailPoliciesSuppliers, ItineraryPoliciesRailPoliciesPolicyType, ItineraryPoliciesRailPoliciesGroupTypes],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'railPolItem',
  canDelete: true
};

const ItineraryPoliciesFlightPolicyExceptionSettingsItem = {
  displayName: 'Item',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesFlightPolicyExceptionSettingsOriginCountryCode, ItineraryPoliciesFlightPolicyExceptionSettingsDestinationCountryCode, ItineraryPoliciesFlightPolicyExceptionSettingsDurationFrom, ItineraryPoliciesFlightPolicyExceptionSettingsDurationTo, ItineraryPoliciesFlightPolicyExceptionSettingsGroupTypes, ItineraryPoliciesFlightPolicyExceptionSettingsPriceTolerance, ItineraryPoliciesFlightPolicyExceptionSettingsLowestFareGroupType, ItineraryPoliciesFlightPolicyExceptionSettingsFlightType, ItineraryPoliciesFlightPolicyExceptionSettingsBenchmarkMostDirect],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'flightPolExcSetItem',
  canDelete: true
};

const ItineraryPoliciesFlightBreakPolicyRulesItem = {
  displayName: 'Item',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.BreakPolicyRules.$flightBreakPolRulItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesFlightBreakPolicyRulesOrigins,
    ItineraryPoliciesFlightBreakPolicyRulesDestinations,
    ItineraryPoliciesFlightBreakPolicyRulesBreakPolicyWindow
  ],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'flightBreakPolRulItem',
  canDelete: true
};

const ItineraryPoliciesFlightBestFareOfFlightItem = {
  displayName: 'Item',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.BestFareOfFlights.$flightBestFareItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ItineraryPoliciesFlightBestFareOfFlightCarriers,
    ItineraryPoliciesFlightBestFareOfFlightCountries,
    ItineraryPoliciesFlightBestFareOfFlightApply
  ],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'flightBestFareItem',
  canDelete: true
};

const ItineraryPoliciesFlightPolicyExceptionsItem = {
  displayName: 'Item',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions.$flightPolExcItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesFlightPolicyExceptionsTitle, ItineraryPoliciesFlightPolicyExceptionsCode, ItineraryPoliciesFlightPolicyExceptionsCountries],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'flightPolExcItem',
  canDelete: true
};

const ItineraryPoliciesFlightPoliciesItem = {
  displayName: 'Policy',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesFlightPoliciesCarrier, ItineraryPoliciesFlightPoliciesBookingCodes, ItineraryPoliciesFlightPoliciesDestinationLocationCode, ItineraryPoliciesFlightPoliciesOriginLocationCode, ItineraryPoliciesFlightPoliciesOriginCountryCode, ItineraryPoliciesFlightPoliciesDestinationCountryCode, ItineraryPoliciesFlightPoliciesDurationType, ItineraryPoliciesFlightPoliciesDurationFrom, ItineraryPoliciesFlightPoliciesDurationTo, ItineraryPoliciesFlightPoliciesGroupTypes, ItineraryPoliciesFlightPoliciesFareClasses, ItineraryPoliciesFlightPoliciesPolicyType],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'flightPolItem',
  canDelete: true
};

const ItineraryPoliciesFlightBenchmarksExceptionsItem = {
  displayName: 'Item',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions.$flightBenchExcItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesFlightBenchmarksExceptionsCarrier, ItineraryPoliciesFlightBenchmarksExceptionsDestinationLocationCode, ItineraryPoliciesFlightBenchmarksExceptionsOriginLocationCode],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'flightBenchExcItem',
  canDelete: true
};

const ItineraryPoliciesFlightBenchmarksPoliciesItem = {
  displayName: 'Item',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Policies.$flightBenchPolItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesFlightBenchmarksPoliciesCarrier, ItineraryPoliciesFlightBenchmarksPoliciesBookingCodes],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'flightBenchPolItem',
  canDelete: true
};

const ItineraryPoliciesItemsItem = {
  displayName: 'Item',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Items.$ItinPolItemIndex',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesItemsCode, ItineraryPoliciesItemsTitle],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'ItinPolItemIndex',
  canDelete: true
};

const DebtorGdsCorporateIdentifiersItemTourCode = {
  displayName: 'Tour Code',
  dataAt: 'Gds.$GdsItem.CorporateIdentifiers.$corpId.TourCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorGdsCorporateIdentifiersItemCorporateCode = {
  displayName: 'Corporate Code',
  dataAt: 'Gds.$GdsItem.CorporateIdentifiers.$corpId.CorporateCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorGdsCorporateIdentifiersItemSupplierCode = {
  displayName: 'Supplier Code',
  dataAt: 'Gds.$GdsItem.CorporateIdentifiers.$corpId.SupplierCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorGdsMiQuestionsItemQuestions = {
  displayName: 'Questions',
  dataAt: 'Gds.$GdsItem.MiQuestions.$MiItem.Questions',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorGdsMiQuestionsItemQuestionsItem,
  gridCols:
    [{ name: 'Question', key: 'Question' },
    { name: 'Answer Format', key: 'AnswerFormat' }]
};

const DebtorGdsMiQuestionsItemSupplier = {
  displayName: 'Supplier',
  dataAt: 'Gds.$GdsItem.MiQuestions.$MiItem.Supplier',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorGdsHotelAggsItemName = {
  displayName: 'Hotel Aggregator Name',
  dataAt: 'Gds.$GdsItem.HotelAggregators.$HotelAggItem.Name',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'HotelAggregators'
};

const DebtorGdsHotelAggsItemEnabled = {
  displayName: 'Enabled',
  dataAt: 'Gds.$GdsItem.HotelAggregators.$HotelAggItem.Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const DebtorGdsHotelAggsPrepaidQuailifierType = {
  displayName: 'Prepaid Type',
  dataAt: 'Gds.$GdsItem.HotelAggregators.$HotelAggItem.PrepaidQualifier',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'PrepaidQualifierTypes'
};


const DebtorGdsHotelAggregatorGridItem = {
  displayName: 'Hotel Aggregators Item',
  dataAt: 'Gds.$GdsItem.HotelAggregators.$HotelAggItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorGdsHotelAggsItemName],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'HotelAggItem',
  canDelete: true
};

const DebtorGdsHotelAggregatorConfiguration = {
  displayName: 'Hotel Aggregators',
  dataAt: 'Gds.$GdsItem.HotelAggregators',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorGdsHotelAggregatorGridItem,
  gridCols: [{ name: 'Name', key: 'Name' }, { name: 'Enabled', key: 'Enabled' }]
};

const DebtorGdsSupplierConfiguration = {
  displayName: 'Supplier Configuration',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorGdsSupplierConfigurationsGridItem,
  gridCols:
    [{ name: 'Suppliers', key: 'Code' }
    ]
};

const DebtorGdsSupplierConfigurationSupplierCode = {
  displayName: 'Supplier Code',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorGdsSupplierConfigurationSettings = {
  displayName: 'Settings',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.Settings',
  displayAs: constants.DISPLAY_AS.KEY_VALUE_PAIRS,
  keyOptions: 'GDSSettingsOptions'
};

const DebtorGdsSupplierConfigurationCountryPairs = {
  displayName: 'Country Pair',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.CountryPairs',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorGdsSupplierConfigurationCountryPairGridItem,
  gridCols:
    [
      {
        name: 'Origins',
        key: 'Origins'
      },
      {
        name: 'Destinations',
        key: 'Destinations'
      },
      {
        name: 'Type',
        key: 'Type'
      }
    ]
};

const DebtorGdsSupplierConfigurationCountryPairOrigins = {
  displayName: 'Origins',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.CountryPairs.$CountryPairItem.Origins',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const DebtorGdsSupplierConfigurationCountryPairDestinations = {
  displayName: 'Destinations',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.CountryPairs.$CountryPairItem.Destinations',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const DebtorGdsSupplierConfigurationCountryPairType = {
  displayName: 'Type',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.CountryPairs.$CountryPairItem.Type',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'CountryPairTypes'
};

const DebtorGdsSupplierConfigurationCountryPairGridItem = {
  displayName: 'Item',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem.CountryPairs.$CountryPairItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    DebtorGdsSupplierConfigurationCountryPairOrigins,
    DebtorGdsSupplierConfigurationCountryPairDestinations,
    DebtorGdsSupplierConfigurationCountryPairType
  ],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'CountryPairItem',
  canDelete: true
};

const DebtorGdsSupplierConfigurationsGridItem = {
  displayName: 'Item',
  dataAt: 'Gds.$GdsItem.SupplierConfigurations.$GdsSplConfigurationItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    DebtorGdsSupplierConfigurationSupplierCode,
    DebtorGdsSupplierConfigurationSettings,
    DebtorGdsSupplierConfigurationCountryPairs
  ],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'GdsSplConfigurationItem',
  canDelete: true
};

const PaymentConfigurationsPaymentTypesConfigurations = {
  displayName: 'Configurations',
  dataAt: 'PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: PaymentTypesConfigurationsItem,
  gridCols: [{ name: 'Sector', key: 'Sector' }]
};

const PaymentConfigurationsPaymentTypesType = {
  displayName: 'Type',
  dataAt: 'PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Type',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'PaymentTypes'
};

const VccIssuerEnhancedDataMappingItemReportKey = {
  displayName: 'Report Key',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem.EnhancedDataMappings.$vccConfigEnhancedDataMapItem.ReportKey',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'VirtualCreditCardIssuerReportKeys',
  filterByKey: 'VirtualCreditCardConfigurations.$vccConfigItem.CardIssuer'
};

const VccIssuerEnhancedDataMappingItemKey = {
  displayName: 'Key',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem.EnhancedDataMappings.$vccConfigEnhancedDataMapItem.Key',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const VccIssuerEnhancedDataMappingItemValue = {
  displayName: 'Value',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem.EnhancedDataMappings.$vccConfigEnhancedDataMapItem.Value',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CompanyReferencesChildrenSort = {
  displayName: 'Sort',
  dataAt: 'CompanyReferences.$compRefItem.Children.$compRefChildItem.Sort',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
}

const CompanyReferencesChildrenMandatory = {
  displayName: 'Mandatory',
  dataAt: 'CompanyReferences.$compRefItem.Children.$compRefChildItem.Mandatory',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const CompanyReferencesChildrenFlags = {
  displayName: 'Flags',
  dataAt: 'CompanyReferences.$compRefItem.Children.$compRefChildItem.Flags',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'CompanyReferencesFlags'
};

const CompanyReferencesChildrenOptions = {
  displayName: 'Options',
  dataAt: 'CompanyReferences.$compRefItem.Children.$compRefChildItem.Options',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const CompanyReferencesChildrenTitle = {
  displayName: 'Title',
  dataAt: 'CompanyReferences.$compRefItem.Children.$compRefChildItem.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CompanyReferencesChildrenCode = {
  displayName: 'Code',
  dataAt: 'CompanyReferences.$compRefItem.Children.$compRefChildItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CompanyReferencesChildrenMatch = {
  displayName: 'Match',
  dataAt: 'CompanyReferences.$compRefItem.Children.$compRefChildItem.Match',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesCarBreakPolicyRules = {
  displayName: 'Break Policy Rules',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.BreakPolicyRules',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesCarBreakPolicyRulesItem,
  gridCols: [
    {
      name: 'Countries',
      key: 'Countries'
    },
    {
      name: 'Break Policy Window (hours)',
      key: 'BreakPolicyWindow'
    }
  ]
};

const ItineraryPoliciesCarPolicyRestriction = {
  displayName: 'Policy Restriction',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesCarPolicyRestrictionItem,
  gridCols: [{ name: 'Suppliers', key: 'Suppliers' },
  { name: 'Location Codes', key: 'LocationCodes' },
  { name: 'Country Codes', key: 'CountryCodes' },
  { name: 'Sipps', key: 'Sipps' },
  { name: 'Maximum Daily Rate', key: 'MaximumDailyRate' },
  { name: 'Policy Type', key: 'PolicyType' }],

};

const ItineraryPoliciesCarPolicyPreferred = {
  displayName: 'Policy Preferred',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesCarPolicyPreferredItem,
  gridCols: [{ name: 'Suppliers', key: 'Suppliers' }]
};

const ItineraryPoliciesCarPolicyExceptionSettings = {
  displayName: 'Break Policy Exceptions',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesCarPolicyExceptionSettingsItem,
  gridCols:
    [{ name: 'Location Codes', key: 'LocationCodes' },
    { name: 'Country Codes', key: 'CountryCodes' },
    { name: 'Supplier Codes', key: 'SupplierCodes' },
    { name: 'Maximum Daily Rate', key: 'MaximumDailyRate' }]
};

const ItineraryPoliciesCarPolicyExceptions = {
  displayName: 'Break Policy Reasons',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesCarPolicyExceptionsItem,
  gridCols:
    [{ name: 'Title', key: 'Title' },
    { name: 'Code', key: 'Code' }],
  excelExport: {
    fileName: 'Car Break Policy Reasons',
    arrayParentRef: {
      name: 'Title',
      dataAt: 'Title'
    },
    cols: [
      {
        name: 'Title',
        dataAt: 'Title'
      },
      {
        name: 'Code',
        dataAt: 'Code'
      },
      {
        name: 'Countries',
        dataAt: 'Countries',
        commaSeparateArray: true,
      }
    ]
  }
};

const ItineraryPoliciesCarPolicies = {
  displayName: 'Car Suppliers',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Car.Policies',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesCarPoliciesItem,
  gridCols:
    [{ name: 'Policy Name', key: 'Name' },
    { name: 'Corporate Code', key: 'CorporateCode' },
    { name: 'Rate', key: 'Rate' },
    { name: 'Supplier', key: 'Supplier.Title' }]
};

const ItineraryPoliciesHotelPoliciesLatLngMap = {
  displayName: 'Policies Lat Long Map',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies',
  displayAs: constants.DISPLAY_AS.LAT_LNG_MAP
};

const ItineraryPoliciesHotelPolicyExceptionSettings = {
  displayName: 'Break Policy Exceptions',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesHotelPolicyExceptionSettingsItem,
  gridCols:
    [{ name: 'Name', key: 'Name' },
    { name: 'Location Code', key: 'LocationCode' },
    { name: 'Country Code', key: 'CountryCode' },
    { name: 'Maximum Daily Rate', key: 'MaximumDailyRate' }]
};

const ItineraryPoliciesHotelBreakPolicyRules = {
  displayName: 'Break Policy Rules',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.BreakPolicyRules',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesHotelBreakPolicyRulesItem,
  gridCols:
    [
      {
        name: 'Countries',
        key: 'Countries'
      },
      {
        name: 'Break Policy Window',
        key: 'BreakPolicyWindow'
      }
    ]
};

const ItineraryPoliciesHotelDefaultPolicyRateMax = {
  displayName: 'Hotel Policy Default Maximum Rate',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.DefaultPolicy.Rate.Max',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesHotelDefaultPolicyRateMin = {
  displayName: 'Hotel Policy Default Minimum Rate',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.DefaultPolicy.Rate.Min',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesHotelPolicyExceptions = {
  displayName: 'Break Policy Reasons',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesHotelPolicyExceptionsItem,
  gridCols:
    [{ name: 'Title', key: 'Title' },
    { name: 'Code', key: 'Code' }],
  excelExport: {
    fileName: 'Hotel Break Policy Reasons',
    arrayParentRef: {
      name: 'Title',
      dataAt: 'Title'
    },
    cols: [
      {
        name: 'Title',
        dataAt: 'Title'
      },
      {
        name: 'Code',
        dataAt: 'Code'
      },
      {
        name: 'Countries',
        dataAt: 'Countries',
        commaSeparateArray: true,
      },
    ]
  }
};

const ItineraryPoliciesHotelDefaultPolicyBenchmarkPreferredAgainstCheapestPreferred = {
  displayName: 'Benchmark Preferred Against Cheapest Preferred',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.DefaultPolicy.BenchmarkPreferredAgainstCheapestPreferred',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const ItineraryPoliciesHotelSettingsExcludedRates = {
  displayName: 'Hotel Excluded Rates',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludedRates',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesHotelSettingsIncludedRates = {
  displayName: 'Restrict Rates by Keyword',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Settings.IncludedRates',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesHotelSettingsExcludedProviders = {
  displayName: 'Hotel Excluded Providers',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludedProviders',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'GDSProviders'
};

const ItineraryPoliciesHotelSettingsRateCodes = {
  displayName: 'Hotel Negotiated Rate Codes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Settings.RateCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesHotelRatePlanCodes = {
  displayName: 'Hotel Rate Plan Codes (Special)',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.RatePlanCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesHotelSabreCslRatePlanCodes = {
  displayName: 'Sabre Csl Rate Plan Codes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.SabreCslRatePlanCodes',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'SabreCslRatePlanCodeOptions'
};

const ItineraryPoliciesHotelSettingsPolicyType = {
  displayName: 'Hotel Policy Type',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Settings.PolicyType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'HotelPolicyTypes'
};

const ItineraryPoliciesHotelPolicies = {
  displayName: 'Policies',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Hotel.Policies',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesHotelPoliciesItem,
  gridCols:
    [{ name: 'Policy Name', key: 'PolicyName' },
    { name: 'Location Code', key: 'LocationCode' },
    { name: 'Country Code', key: 'CountryCode' }],
  excelExport: {
    fileName: 'Hotel Policies',
    asyncLookup: {
      api: `${endPointUrl}/api/v2/Hotels/getproviderhotelbyexternalids`,
      dataAt: ['Hotels', 'SabreCslHotels'],
      asyncColName: 'Hotel Name',
    },
    arrayParentRef: {
      name: 'Policy Name',
      dataAt: 'PolicyName'
    },
    cols: [
      {
        name: 'Policy Name',
        dataAt: 'PolicyName'
      },
      {
        name: 'Policies Country Code',
        dataAt: 'CountryCode'
      },
      {
        name: 'Policies Location Code',
        dataAt: 'LocationCode'
      },
      {
        name: 'Hotel ID',
        dataAt: 'Hotels',
        isArray: true,
        asyncId: 'ExternalId',
        asyncColName: 'Hotel Name',
        asyncKey: 'Name',
      },
      {
        name: 'SabreCsl Hotels',
        dataAt: 'SabreCslHotels',
        isArray: true,
        asyncId: 'ExternalId',
        asyncColName: 'Hotel Name',
        asyncKey: 'Name',
      },
      {
        name: 'Minimum Rate',
        dataAt: 'Rate.Min'
      },
      {
        name: 'Maximum Rate',
        dataAt: 'Rate.Max'
      },
      {
        name: 'Chain Codes',
        dataAt: 'ChainCodes',
        isArray: true,
      },
      {
        name: 'Post Code',
        dataAt: 'PostCode'
      },
      {
        name: 'Minimum Rating',
        dataAt: 'MinimumHotelRating'
      },
      {
        name: 'Excluded Chains',
        dataAt: 'ExcludedChainCodes',
        isArray: true,
      },
      {
        name: 'Excluded Hotels',
        dataAt: 'ExcludedHotels',
        isArray: true,
      },
      {
        name: 'Policy Radius',
        dataAt: 'Radius'
      },
      {
        name: 'Policy Latitude',
        dataAt: 'Latitude'
      },
      {
        name: 'Policy Longitude',
        dataAt: 'Longitude'
      }
    ]
  }
};

const ItineraryPoliciesRailExcludedSuppliers = {
  displayName: 'Rail Excluded Suppliers',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Rail.ExcludedSuppliers',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesRailPolicyExceptions = {
  displayName: 'Policy Exceptions',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesRailPolicyExceptionsItem,
  gridCols:
    [{ name: 'Title', key: 'Title' },
    { name: 'Code', key: 'Code' }]
};

const ItineraryPoliciesRailPolicies = {
  displayName: 'Policies',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Rail.Policies',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesRailPoliciesItem,
  gridCols:
    [{ name: 'Suppliers', key: 'Suppliers' },
    { name: 'Policy Type', key: 'PolicyType' },
    { name: 'Group Type', key: 'GroupTypes' }]
};

const ItineraryPoliciesFlightPolicyExceptionSettings = {
  displayName: 'Break Policy Exceptions',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesFlightPolicyExceptionSettingsItem,
  gridCols:
    [{ name: 'Origin Country Code', key: 'OriginCountryCode' },
    {
      name: 'Destination Country Code',
      key: 'DestinationCountryCode'
    },
    { name: 'Type', key: 'FlightType' },
    { name: 'Price Tolerance', key: 'PriceTolerance' },
    { name: 'Benchmark Most Direct', key: 'BenchmarkMostDirect' }]
};

const ItineraryPoliciesFlightBreakPolicyRules = {
  displayName: 'Break Policy Rules',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.BreakPolicyRules',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesFlightBreakPolicyRulesItem,
  gridCols:
    [
      {
        name: 'Origins',
        key: 'Origins'
      },
      {
        name: 'Destinations',
        key: 'Destinations'
      },
      {
        name: 'Break Policy Window',
        key: 'BreakPolicyWindow'
      }
    ]
};

const ItineraryPoliciesFlightBestFareOfFlights = {
  displayName: 'Best Fare Of Flights',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.BestFareOfFlights',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesFlightBestFareOfFlightItem,
  gridCols:
    [
      {
        name: 'Carriers',
        key: 'Carriers'
      },
      {
        name: 'Countries',
        key: 'Countries'
      },
      {
        name: 'Apply',
        key: 'Apply'
      }
    ]
};

const ItineraryPoliciesFlightPolicyExceptionExcludedCarriers = {
  displayName: 'Policy Exception Excluded Carriers',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionExcludedCarriers',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesFlightPolicyExceptions = {
  displayName: 'Break Policy Reasons',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesFlightPolicyExceptionsItem,
  gridCols:
    [{ name: 'Title', key: 'Title' },
    { name: 'Code', key: 'Code' }],
  excelExport: {
    fileName: 'Flight Break Policy Reasons',
    arrayParentRef: {
      name: 'Title',
      dataAt: 'Title'
    },
    cols: [
      {
        name: 'Title',
        dataAt: 'Title'
      },
      {
        name: 'Code',
        dataAt: 'Code'
      },
      {
        name: 'Countries',
        dataAt: 'Countries',
        commaSeparateArray: true,
      },
    ]
  }
};

const ItineraryPoliciesFlightSettingsRateCodes = {
  displayName: 'Flight Rate Codes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Settings.RateCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesFlightSettingsPolicyType = {
  displayName: 'Flight Policy Type',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Settings.PolicyType',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'AirlinePolicyTypes'
};

const ItineraryPoliciesFlightSettingsExcludedRates = {
  displayName: 'Flight Excluded Rates',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Settings.ExcludedRates',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const ItineraryPoliciesFlightSettingsExcludedProviders = {
  displayName: 'Flight Excluded Providers',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Settings.ExcludedProviders',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'GDSProviders'
};

const ItineraryPoliciesFlightPolicies = {
  displayName: 'Policies',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Policies',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesFlightPoliciesItem,
  gridCols:
    [{ name: 'Carrier', key: 'Carrier' },
    {
      name: 'Destination Location Code',
      key: 'DestinationLocationCode'
    },
    { name: 'Origin Location Code', key: 'OriginLocationCode' },
    { name: 'Group Type', key: 'GroupTypes' },
    { name: 'Policy Type', key: 'PolicyType' }],
  excelExport: {
    fileName: 'Flight Policies',
    arrayParentRef: {
      name: 'Carrier',
      dataAt: 'Carrier'
    },
    cols: [
      {
        name: 'Carrier',
        dataAt: 'Carrier'
      },
      {
        name: 'Booking Codes',
        dataAt: 'BookingCodes',
        commaSeparateArray: true,
      },
      {
        name: 'Origin Location Code',
        dataAt: 'OriginLocationCode',
      },
      {
        name: 'Destination Location Code',
        dataAt: 'DestinationLocationCode'
      },
      {
        name: 'Origin Country Code',
        dataAt: 'OriginCountryCode',
      },
      {
        name: 'Destination Country Code',
        dataAt: 'DestinationCountryCode'
      },
      {
        name: 'Duration Type',
        dataAt: 'DurationType',
      },
      {
        name: 'Duration From',
        dataAt: 'DurationFrom',
      },
      {
        name: 'Duration To',
        dataAt: 'DurationTo',
      },
      {
        name: 'Group Type',
        dataAt: 'GroupTypes',
        commaSeparateArray: true,
      },
      {
        name: 'Fare Classes',
        dataAt: 'FareClasses',
        commaSeparateArray: true,
      },
      {
        name: 'Policy Type',
        dataAt: 'PolicyType',
      }
    ]
  }
};

const ItineraryPoliciesFlightBenchmarksExceptions = {
  displayName: 'Benchmark Exceptions',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesFlightBenchmarksExceptionsItem,
  gridCols:
    [{ name: 'Carrier', key: 'Carrier' },
    {
      name: 'DestinationLocationCode',
      key: 'DestinationLocationCode'
    },
    { name: 'OriginLocationCode', key: 'OriginLocationCode' }]
};

const ItineraryPoliciesFlightBenchmarksPolicies = {
  displayName: 'Benchmark Policies',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Policies',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesFlightBenchmarksPoliciesItem,
  gridCols: [{ name: 'Carrier', key: 'Carrier' }]
};

const TravelIntentQuestionsChildrenSort = {
  displayName: 'Sort',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Children.$TravelIntentQuestionChildIndex.Sort',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const TravelIntentQuestionsChildrenMandatory = {
  displayName: 'Mandatory',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Children.$TravelIntentQuestionChildIndex.Mandatory',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const TravelIntentQuestionsChildrenOptions = {
  displayName: 'Options',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Children.$TravelIntentQuestionChildIndex.Options',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const TravelIntentQuestionsChildrenDescription = {
  displayName: 'Description',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Children.$TravelIntentQuestionChildIndex.Description',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const TravelIntentQuestionsChildrenTitle = {
  displayName: 'Title',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Children.$TravelIntentQuestionChildIndex.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const TravelIntentQuestionsChildrenCode = {
  displayName: 'Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Children.$TravelIntentQuestionChildIndex.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const TravelIntentQuestionsChildrenMatch = {
  displayName: 'Match',
  dataSource: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Options',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Children.$TravelIntentQuestionChildIndex.Match',
  displayAs: constants.DISPLAY_AS.TAG_SELECT
};

const TravelIntentQuestionsChildrenItem = {
  displayName: 'Children',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Children.$TravelIntentQuestionChildIndex',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [TravelIntentQuestionsChildrenMatch, TravelIntentQuestionsChildrenCode, TravelIntentQuestionsChildrenTitle,
    TravelIntentQuestionsChildrenDescription, TravelIntentQuestionsChildrenOptions,
    TravelIntentQuestionsChildrenMandatory, TravelIntentQuestionsChildrenSort],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'TravelIntentQuestionChildIndex',
  canDelete: true
};

const TravelIntentQuestionsChildren = {
  displayName: 'Children',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Children',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: TravelIntentQuestionsChildrenItem,
  gridCols:
    [{ name: 'Match', key: 'Match' },
    { name: 'Code', key: 'Code' },
    { name: 'Title', key: 'Title' },
    { name: 'Sort', key: 'Sort' }],
  excelExport: {
    fileName: 'Travel Intent Q\'s Children',
    arrayParentRef: {
      name: 'Match',
      dataAt: 'Match'
    },
    cols: [
      {
        name: 'Match',
        dataAt: 'Match'
      },
      {
        name: 'Code',
        dataAt: 'Code'
      },
      {
        name: 'Title',
        dataAt: 'Title'
      },
      {
        name: 'Description',
        dataAt: 'Description'
      },
      {
        name: 'Options',
        dataAt: 'Options',
        commaSeparateArray: true,
      },
      {
        name: 'Mandatory',
        dataAt: 'Mandatory',
        isBoolean: true
      },
      {
        name: 'Sort',
        dataAt: 'Sort'
      },
    ],
  }
};

const TravelIntentQuestionsSort = {
  displayName: 'Sort',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Sort',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
}

const TravelIntentQuestionsMandatory = {
  displayName: 'Mandatory',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Mandatory',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const TravelIntentQuestionsOptions = {
  displayName: 'Options',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Options',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const TravelIntentQuestionsDescription = {
  displayName: 'Description',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Description',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const TravelIntentQuestionsCompanyReferenceLink = {
  displayName: 'Company Reference Link',
  dataSource: 'CompanyReferences',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.CompanyReferenceLink',
  displayAs: constants.DISPLAY_AS.COMPANY_REFERENCE_SELECT
};

const TravelIntentQuestionsTitle = {
  displayName: 'Title',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const TravelIntentQuestionsCode = {
  displayName: 'Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const TravelIntentQuestionsItem = {
  displayName: 'Item',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions.$TravelIntentQuestionIndex',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [TravelIntentQuestionsCode, TravelIntentQuestionsCompanyReferenceLink, TravelIntentQuestionsTitle,
    TravelIntentQuestionsDescription, TravelIntentQuestionsOptions, TravelIntentQuestionsMandatory,
    TravelIntentQuestionsSort, TravelIntentQuestionsChildren],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'TravelIntentQuestionIndex',
  canDelete: true
};

const TravelIntentQuestions = {
  displayName: 'Travel Intent Questions',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.TravelIntent.Questions',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: TravelIntentQuestionsItem,
  gridCols:
    [{ name: 'Code', key: 'Code' },
    { name: 'Title', key: 'Title' },
    { name: 'Sort', key: 'Sort' }],
  excelExport: {
    fileName: 'Travel Intent Questions',
    arrayParentRef: {
      name: 'Code',
      dataAt: 'Code'
    },
    cols: [
      {
        name: 'Code',
        dataAt: 'Code'
      },
      {
        name: 'Company Reference Link',
        dataAt: 'CompanyReferenceLink'
      },
      {
        name: 'Title',
        dataAt: 'Title'
      },
      {
        name: 'Description',
        dataAt: 'Description'
      },
      {
        name: 'Options',
        dataAt: 'Options',
        commaSeparateArray: true,
      },
      {
        name: 'Mandatory',
        dataAt: 'Mandatory',
        isBoolean: true
      },
      {
        name: 'Sort',
        dataAt: 'Sort'
      },
    ]
  }
};

const ItineraryPoliciesItems = {
  displayName: 'Employee Types',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Items',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesItemsItem,
  gridCols:
    [{ name: 'Code', key: 'Code' },
    { name: 'Title', key: 'Title' }]
};

const DebtorApproversTravellersEmail = {
  displayName: 'Email',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.Travellers.$travellersIndex.Email',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'email'
};

const DebtorApproversTravellersTitle = {
  displayName: 'Title',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.Travellers.$travellersIndex.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorApproversTravellersId = {
  displayName: 'Id',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.Travellers.$travellersIndex.Id',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorApproversPolicyCodeTiersPolicyCode = {
  displayName: 'Policy Code',
  dataSource: 'ItineraryPolicies',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.PolicyCodeTiers.$policyCodeTiersIndex.PolicyCode',
  displayAs: constants.DISPLAY_AS.POLICY_CODE_SELECT
};

const DebtorApproversPolicyCodeTiersTier = {
  displayName: 'Tier',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.PolicyCodeTiers.$policyCodeTiersIndex.Tier',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};


const DebtorGdsCorporateIdentifiersItem = {
  displayName: 'Corporate Identifiers Item',
  dataAt: 'Gds.$GdsItem.CorporateIdentifiers.$corpId',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorGdsCorporateIdentifiersItemSupplierCode, DebtorGdsCorporateIdentifiersItemCorporateCode, DebtorGdsCorporateIdentifiersItemTourCode],
  endpoint: 'Debtors',
  removeParamId: 'corpId',
  canDelete: true
};

const DebtorGdsMiQuestionsItem = {
  displayName: 'Mi Questions Item',
  dataAt: 'Gds.$GdsItem.MiQuestions.$MiItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorGdsMiQuestionsItemSupplier, DebtorGdsMiQuestionsItemQuestions],
  endpoint: 'Debtors',
  removeParamId: 'MiItem',
  canDelete: true
};

const DebtorGdsHotelAggsItem = {
  displayName: 'Hotel Aggregators Item',
  dataAt: 'Gds.$GdsItem.HotelAggregators.$HotelAggItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorGdsHotelAggsItemName, DebtorGdsHotelAggsItemEnabled],
  endpoint: 'Debtors',
  removeParamId: 'HotelAggItem',
  canDelete: true
};

const PaymentTypesItem = {
  displayName: 'Payment Type',
  dataAt: 'PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [PaymentConfigurationsPaymentTypesType, PaymentConfigurationsPaymentTypesConfigurations],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'payConPayTypItem',
  canDelete: true
};

const VirtualCreditCardIssuerEnhancedDataMappingsItem = {
  displayName: 'Card Issuer Enhanced Data Mapping',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem.EnhancedDataMappings.$vccConfigEnhancedDataMapItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [VccIssuerEnhancedDataMappingItemReportKey, VccIssuerEnhancedDataMappingItemKey, VccIssuerEnhancedDataMappingItemValue],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'vccConfigEnhancedDataMapItem',
  canDelete: true
}

const CompanyReferencesChildrenItem = {
  displayName: 'Children',
  dataAt: 'CompanyReferences.$compRefItem.Children.$compRefChildItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [CompanyReferencesChildrenMatch, CompanyReferencesChildrenCode, CompanyReferencesChildrenTitle, CompanyReferencesChildrenOptions, CompanyReferencesChildrenFlags, CompanyReferencesChildrenMandatory, CompanyReferencesChildrenSort],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'compRefChildItem',
  canDelete: true
};

const ItineraryPoliciesCar = {
  tabName: 'Car',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ItineraryPoliciesCarPolicies, ItineraryPoliciesCarPolicyExceptions, ItineraryPoliciesCarPolicyExceptionSettings, ItineraryPoliciesCarPolicyPreferred, ItineraryPoliciesCarPolicyRestriction, ItineraryPoliciesCarBreakPolicyRules]
};

const ItineraryPoliciesHotel = {
  tabName: 'Hotel',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ItineraryPoliciesHotelPolicies, ItineraryPoliciesHotelSettingsPolicyType, ItineraryPoliciesHotelSettingsRateCodes, ItineraryPoliciesHotelRatePlanCodes, ItineraryPoliciesHotelSabreCslRatePlanCodes, ItineraryPoliciesHotelSettingsExcludedProviders, ItineraryPoliciesHotelSettingsIncludedRates, ItineraryPoliciesHotelSettingsExcludedRates, ItineraryPoliciesHotelDefaultPolicyBenchmarkPreferredAgainstCheapestPreferred, ItineraryPoliciesHotelPolicyExceptions, ItineraryPoliciesHotelDefaultPolicyRateMin, ItineraryPoliciesHotelDefaultPolicyRateMax, ItineraryPoliciesHotelPolicyExceptionSettings, ItineraryPoliciesHotelBreakPolicyRules, ItineraryPoliciesHotelPoliciesLatLngMap]
};

const ItineraryPoliciesRail = {
  tabName: 'Rail',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ItineraryPoliciesRailPolicies, ItineraryPoliciesRailPolicyExceptions, ItineraryPoliciesRailExcludedSuppliers]
};

const ItineraryPoliciesFlight = {
  tabName: 'Flight',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ItineraryPoliciesFlightBenchmarksPolicies, ItineraryPoliciesFlightBenchmarksExceptions, ItineraryPoliciesFlightPolicies, ItineraryPoliciesFlightSettingsExcludedProviders, ItineraryPoliciesFlightSettingsExcludedRates, ItineraryPoliciesFlightSettingsPolicyType, ItineraryPoliciesFlightSettingsRateCodes, ItineraryPoliciesFlightPolicyExceptions, ItineraryPoliciesFlightPolicyExceptionExcludedCarriers, ItineraryPoliciesFlightPolicyExceptionSettings, ItineraryPoliciesFlightBreakPolicyRules, ItineraryPoliciesFlightBestFareOfFlights]
};

const ItineraryPoliciesGeneral = {
  tabName: 'General',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ItineraryPoliciesItems, TravelIntentQuestions]
};

const DebtorApproversTravellersItem = {
  displayName: 'Debtor Approver',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.Travellers.$travellersIndex',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorApproversTravellersId, DebtorApproversTravellersTitle, DebtorApproversTravellersEmail],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'travellersIndex',
  canDelete: true
};

const DebtorApproversPolicyCodeTiersItem = {
  displayName: 'Debtor Approver',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.PolicyCodeTiers.$policyCodeTiersIndex',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorApproversPolicyCodeTiersPolicyCode, DebtorApproversPolicyCodeTiersTier],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'policyCodeTiersIndex',
  canDelete: true
};


const DebtorGdsCorporateIdentifiers = {
  displayName: 'Corporate Identifiers',
  dataAt: 'Gds.$GdsItem.CorporateIdentifiers',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorGdsCorporateIdentifiersItem,
  gridCols:
    [{ name: 'Supplier Code', key: 'SupplierCode' },
    { name: 'Corporate Code', key: 'CorporateCode' },
    { name: 'Tour Code', key: 'TourCode' }]
};

const DebtorGdsMiQuestions = {
  displayName: 'Mi Questions',
  dataAt: 'Gds.$GdsItem.MiQuestions',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorGdsMiQuestionsItem,
  gridCols: [{ name: 'Supplier', key: 'Supplier' }]
};

const DebtorGdsSettings = {
  displayName: 'Settings',
  dataAt: 'Gds.$GdsItem.Settings',
  displayAs: constants.DISPLAY_AS.KEY_VALUE_PAIRS,
  keyOptions: 'GDSSettingsOptions'
};

const DebtorGdsEnabled = {
  displayName: 'Enabled',
  dataAt: 'Gds.$GdsItem.Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const DebtorGdsName = {
  displayName: 'Name',
  dataAt: 'Gds.$GdsItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const HotelConfigurationPaymentNarrativesIsDomesticOnly = {
  displayName: 'Is Domestic Only',
  dataAt: 'HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.IsDomesticOnly',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const HotelConfigurationPaymentNarrativesProviders = {
  displayName: 'Hotel Providers',
  dataAt: 'HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.Providers',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'GDSProviders'
};

const HotelConfigurationPaymentNarrativesAggregatorTypes = {
  displayName: 'Content Aggregator',
  dataAt: 'HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.AggregatorTypes',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'HotelSectorAggregatorTypes'
}

const HotelConfigurationPaymentNarrativesServiceFeeCode = {
  displayName: 'Service Fee Code',
  dataAt: 'HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.ServiceFeeCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const HotelConfigurationPaymentNarrativesPaymentInstructions = {
  displayName: 'Hotel Payment Instructions',
  dataAt: 'HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.PaymentInstructions',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const HotelConfigurationPaymentNarrativesPaymentNarrative = {
  displayName: 'Hotel Payment Narrative (max 50 characters)',
  dataAt: 'HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.PaymentNarrative',
  maxLength: 50,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const HotelConfigurationPaymentNarrativesPaymentCode = {
  displayName: 'Hotel Payment Code',
  dataAt: 'HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.PaymentCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const HotelConfigurationRadiusCitiesRadius = {
  displayName: 'Radius',
  dataAt: 'HotelConfiguration.Radius.Cities.$hotConRadCitiesItem.Radius',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'RadiusOptions',
  optionsNumbers: true,
  required: true
};

const HotelConfigurationRadiusCitiesCityCode = {
  displayName: 'CityCode',
  dataAt: 'HotelConfiguration.Radius.Cities.$hotConRadCitiesItem.CityCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const RailSupplierSettingsSettings = {
  displayName: 'Settings',
  dataAt: 'RailConfiguration.RailSupplierSettings.$railSuppSettingItem.Settings',
  displayAs: constants.DISPLAY_AS.KEY_VALUE_PAIRS
};

const RailSupplierSettingsCode = {
  displayName: 'Code',
  dataAt: 'RailConfiguration.RailSupplierSettings.$railSuppSettingItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const RailSupplierSettingsName = {
  displayName: 'Name',
  dataAt: 'RailConfiguration.RailSupplierSettings.$railSuppSettingItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const FlightSearchWindowsDestinations = {
  displayName: 'Destinations',
  dataAt: 'FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.Destinations',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const FlightSearchWindowsOrigins = {
  displayName: 'Origins',
  dataAt: 'FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.Origins',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const FlightSearchWindowsFlightPolicyDepartureWindowTo = {
  displayName: 'Policy Departure Window To',
  dataAt: 'FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.FlightPolicyDepartureWindowTo',
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 15,
  max: 720,
  step: 15,
  defaultValue: 3,
  divideResultBy: 60,
  units: 'minutes'
};

const FlightSearchWindowsFlightPolicyDepartureWindowFrom = {
  displayName: 'Policy Departure Window From',
  dataAt: 'FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.FlightPolicyDepartureWindowFrom',
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 15,
  max: 720,
  step: 15,
  defaultValue: 3,
  divideResultBy: 60,
  units: 'minutes'
};

const FlightSearchWindowsFlightSearchWindowTo = {
  displayName: 'Search Window To',
  dataAt: 'FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.FlightSearchWindowTo',
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 15,
  max: 720,
  step: 15,
  defaultValue: 3,
  divideResultBy: 60,
  units: 'minutes'
};

const FlightSearchWindowsFlightSearchWindowFrom = {
  displayName: 'Search Window From',
  dataAt: 'FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.FlightSearchWindowFrom',
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 15,
  max: 720,
  step: 15,
  defaultValue: 3,
  divideResultBy: 60,
  units: 'minutes'
};

const FlightSearchWindowsIsAllDaySearch = {
  displayName: 'Is All Day Search',
  dataAt: 'FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.IsAllDaySearch',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const CombinableFareRulesDestination = {
  displayName: 'Destination',
  dataAt: 'FlightConfiguration.CombinableFareRules.$combFareRulesItem.Destination',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single'
};

const CombinableFareRulesOrigin = {
  displayName: 'Origin',
  dataAt: 'FlightConfiguration.CombinableFareRules.$combFareRulesItem.Origin',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single'
};

const OneWayFareRulesDestination = {
  displayName: 'Destination',
  dataAt: 'FlightConfiguration.OneWayFareRules.$oneWayFarRuItem.Destination',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single'
};

const OneWayFareRulesOrigin = {
  displayName: 'Origin',
  dataAt: 'FlightConfiguration.OneWayFareRules.$oneWayFarRuItem.Origin',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single'
};

const PaymentConfigurationsPaymentTypes = {
  displayName: 'Payment Types',
  dataAt: 'PaymentConfigurations.$payConItem.PaymentTypes',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: PaymentTypesItem,
  gridCols: [{ name: 'Type', key: 'Type' }]
};

const PaymentConfigurationsProvider = {
  displayName: 'Provider',
  dataAt: 'PaymentConfigurations.$payConItem.Provider',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'GDSProviders'
};

const VirtualCreditCardConfigurationsCardPoolId = {
  displayName: 'Card Pool Id',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem.CardPoolId',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
}

const VirtualCreditCardConfigurationsCardIssuer = {
  displayName: 'Card Issuer',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem.CardIssuer',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'VirtualCreditCardIssuers'
}

const VirtualCreditCardConfigurationsCardCode = {
  displayName: 'Card Code',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem.CardCode',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'cardType'
}

const VirtualCreditCardConfigurationsAgentId = {
  displayName: 'Agent Id',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem.AgentId',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
}

const VirtualCreditCardConfigurationsCardProvider = {
  displayName: 'Supplier',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem.Provider',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'GDSProviders'
}

const VirtualCreditCardConfigurationsCardSegmentTypes = {
  displayName: 'Segment Types',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem.SegmentTypes',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'SegmentTypes'
}

const VirtualCreditCardConfigurationsCardAggregatorTypes = {
  displayName: 'Content Aggregator',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem.AggregatorTypes',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'AggregatorTypes'
}

const VirtualCreditCardConfigurationsCardIssuerEnhancedDataMappings = {
  displayName: 'Enhanced Data Mappings',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem.EnhancedDataMappings',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: VirtualCreditCardIssuerEnhancedDataMappingsItem,
  gridCols: [{ name: 'Report Key', key: 'ReportKey' },
  { name: 'Key', key: 'Key' },
  { name: 'Value', key: 'Value' }]
}

const VirtualCreditCardConfigurationsCardDisplayName = {
  displayName: 'Card Display Name',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem.CardDisplayName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'This is the card name that will display in the payment modal for this Virtual Credit Card'
}
const DebtorAgencyReasonCodesTitle = {
  displayName: 'Title',
  dataAt: 'DebtorAgencyReasonCodes.$debAgReCoItem.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAgencyReasonCodesCode = {
  displayName: 'Code',
  dataAt: 'DebtorAgencyReasonCodes.$debAgReCoItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AgencyCreditCardsItemModifiedOn = {
  displayName: 'Modified On',
  dataAt: 'DebtorAgencyCreditCards.$debtAgCCItem.ModifiedOn',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AgencyCreditCardsItemModifiedBy = {
  displayName: 'Modified By',
  dataAt: 'DebtorAgencyCreditCards.$debtAgCCItem.ModifiedBy',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AgencyCreditCardsItemCreatedOn = {
  displayName: 'Created On',
  dataAt: 'DebtorAgencyCreditCards.$debtAgCCItem.CreatedOn',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AgencyCreditCardsItemCreatedBy = {
  displayName: 'Created By',
  dataAt: 'DebtorAgencyCreditCards.$debtAgCCItem.CreatedBy',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const SegmentTypes = {
  displayName: 'Segment Types',
  dataAt: 'DebtorAgencyCreditCards.$debtAgCCItem.SegmentTypes',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'SegmentTypes'
};

const CreditCardId = {
  displayName: 'Credit Card Id',
  dataAt: 'DebtorAgencyCreditCards.$debtAgCCItem.CreditCardId',
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  endpoint: 'CreditCards'
};

const CreditCardProvider = {
  displayName: 'Supplier',
  dataAt: 'DebtorAgencyCreditCards.$debtAgCCItem.Provider',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'GDSProviders'
};

const AgencyCreditCardsItemId = {
  displayName: 'Id',
  dataAt: 'DebtorAgencyCreditCards.$debtAgCCItem.Id',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const AgencyCreditCardsItemTitle = {
  displayName: 'Title',
  dataAt: 'DebtorAgencyCreditCards.$debtAgCCItem.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CompanyReferencesChildren = {
  displayName: 'Children',
  dataAt: 'CompanyReferences.$compRefItem.Children',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CompanyReferencesChildrenItem,
  gridCols:
    [{ name: 'Match', key: 'Match' },
    { name: 'Code', key: 'Code' },
    { name: 'Title', key: 'Title' },
    { name: 'Mandatory', key: 'Mandatory' },
    { name: 'Sort', key: 'Sort' }],
  excelExport: {
    fileName: 'Company References Children',
    arrayParentRef: {
      name: 'Match',
      dataAt: 'Match'
    },
    disableImport: true,
    cols: [
      {
        name: 'Match',
        dataAt: 'Match'
      },
      {
        name: 'Code',
        dataAt: 'Code'
      },
      {
        name: 'Title',
        dataAt: 'Title'
      },
      {
        name: 'Options',
        dataAt: 'Options',
        commaSeparateArray: true,
      },
      {
        name: 'Flags',
        dataAt: 'Flags',
        commaSeparateArray: true,
      },
      {
        name: 'Mandatory',
        dataAt: 'Mandatory',
        isBoolean: true
      },
    ],
  }
};

const CompanyReferencesMandatory = {
  displayName: 'Mandatory',
  dataAt: 'CompanyReferences.$compRefItem.Mandatory',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const CompanyReferencesFlags = {
  displayName: 'Flags',
  dataAt: 'CompanyReferences.$compRefItem.Flags',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'CompanyReferencesFlags'
};

const CompanyReferencesOptions = {
  displayName: 'Options',
  dataAt: 'CompanyReferences.$compRefItem.Options',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const CompanyReferencesTitle = {
  displayName: 'Title',
  dataAt: 'CompanyReferences.$compRefItem.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CompanyReferencesCode = {
  displayName: 'Code',
  dataAt: 'CompanyReferences.$compRefItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CompanyReferencesSort = {
  displayName: 'Sort',
  dataAt: 'CompanyReferences.$compRefItem.Sort',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const ItineraryPoliciesTabs = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.TABS,
  children: [ItineraryPoliciesGeneral, ItineraryPoliciesFlight, ItineraryPoliciesRail, ItineraryPoliciesHotel, ItineraryPoliciesCar]
};

const ItineraryPoliciesReasonsForTravel = {
  displayName: 'Reasons for travel',
  dataSource: 'DebtorAgencyReasonCodes',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.ReasonsForTravel',
  displayAs: constants.DISPLAY_AS.REASON_FOR_TRAVEL_SELECT
};

const ItineraryPoliciesApprovalTiers = {
  displayName: 'Approval Tiers',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.ApprovalTiers',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  min: 1,
  max: 99
};


const ItineraryPoliciesBreakPolicyEscalationApprovalLevel = {
  displayName: 'Break Policy Escalation Approval Level',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.BreakPolicyEscalationApprovalLevel',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'approvalLevels'
};

const ItineraryPoliciesApprovalLevel = {
  displayName: 'Approval Level',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.ApprovalLevel',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'approvalLevels'
};

const ItineraryPoliciesCountries = {
  displayName: 'Countries',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Countries',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const ItineraryPoliciesTitle = {
  displayName: 'Title',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ItineraryPoliciesCode = {
  displayName: 'Code',
  dataAt: 'ItineraryPolicies.$ItinPolIndex.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorApproversEnabled = {
  displayName: 'Debtor Approver Enabled',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const DebtorApproversPolicyCodeTiers = {
  displayName: 'PolicyCodeTiers',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.PolicyCodeTiers',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorApproversPolicyCodeTiersItem,
  gridCols:
    [{ name: 'PolicyCode', key: 'PolicyCode' },
    { name: 'Tier', key: 'Tier' }]
};


const DebtorApproversTravellers = {
  displayName: 'Travellers',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.Travellers',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorApproversTravellersItem,
  gridCols:
    [{ name: 'Id', key: 'Id' },
    { name: 'Title', key: 'Title' },
    { name: 'Email', key: 'Email' }]
};

const DebtorApproversDepartments = {
  displayName: 'Debtor Departments',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.Departments',
  displayAs: constants.DISPLAY_AS.O_DATA_INDEX_MULTI_SELECT,
  windowVar: 'travellersSearch',
  index: 'departments',
  suggester: 'departmentsg',
  apiVersion: '2016-09-01',
  searchId: 'Name',
  searchFields: ['DepartmentName', 'DepartmentCode'],
  valueField: 'DepartmentCode',
  titleField: 'DepartmentName'
};

const DebtorApproversCostCentres = {
  displayName: 'Debtor Cost Centres',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.CostCentres',
  displayAs: constants.DISPLAY_AS.O_DATA_INDEX_MULTI_SELECT,
  windowVar: 'travellersSearch',
  index: 'costcentres',
  suggester: 'costcentresg',
  apiVersion: '2016-09-01',
  searchId: 'Name',
  searchFields: ['CostCentreCode', 'CostCentreName'],
  valueField: 'CostCentreCode',
  titleField: 'CostCentreName'
};

const DebtorApproversEmail = {
  displayName: 'Debtor Approvers Email',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.Email',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'email'
};

const DebtorApproversLastName = {
  displayName: 'Debtor Approvers Last Name',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.LastName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorApproversFirstName = {
  displayName: 'Debtor Approvers First Name',
  dataAt: 'DebtorApprovers.$debtorApproversIndex.FirstName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const TermsAndConditionsText = {
  displayName: 'Text',
  dataAt: 'TermsAndConditions.$debtorTermsItem.Text',
  displayAs: constants.DISPLAY_AS.TEXT_AREA
};

const TermsAndConditionsSegmentTypes = {
  displayName: 'Segment Types',
  dataAt: 'TermsAndConditions.$debtorTermsItem.SegmentTypes',
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: 'SegmentTypes'
};

const TermsAndConditionsCountries = {
  displayName: 'Countries',
  dataAt: 'TermsAndConditions.$debtorTermsItem.Countries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const DebtorOrderNumberCodesTitle = {
  displayName: 'Title',
  dataAt: 'DebtorOrderNumberCodes.$debtorOrderNumberCodesIndex.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const DebtorOrderNumberCodesCode = {
  displayName: 'Code',
  dataAt: 'DebtorOrderNumberCodes.$debtorOrderNumberCodesIndex.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const DebtorAgencyChangeFeesName = {
  displayName: 'Name',
  dataAt: 'AgencyChangeFees.$debAgChangeFeesItem.Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAgencyChangeFeesAmount = {
  displayName: 'Amount',
  dataAt: 'AgencyChangeFees.$debAgChangeFeesItem.Amount',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const DebtorAgencyChangeFeesCountries = {
  displayName: 'Countries',
  dataAt: 'AgencyChangeFees.$debAgChangeFeesItem.Countries',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT
};

const DebtorAgencyChangeFeesServiceFeeCode = {
  displayName: 'Service Fee Code',
  dataAt: 'AgencyChangeFees.$debAgChangeFeesItem.ServiceFeeCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const EnableAirEmissions = {
  displayName: 'Enable Air Emissions',
  dataAt: 'CarbonEmissionSetting.EnableAirEmissions',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: 'This option will enable flight CO2 emissions to display',
  prerequisiteFor: ['CarbonEmissionSetting.IncludeAirEmissionsInTotals']
}

const IncludeAirEmissionsInTotals = {
  displayName: 'Include Air Emissions in Totals',
  dataAt: 'CarbonEmissionSetting.IncludeAirEmissionsInTotals',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: 'This option will include flight emissions to be included in booking totals',
  prerequisiteFor: ['CarbonEmissionSetting.EnableEmissionsTotal']
}

const EnableCarEmissions = {
  displayName: 'Enable Car Emissions',
  dataAt: 'CarbonEmissionSetting.EnableCarEmissions',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: 'This option will enable car CO2 emissions to display',
  prerequisiteFor: ['CarbonEmissionSetting.IncludeCarEmissionsInTotals']
}

const IncludeCarEmissionsInTotals = {
  displayName: 'Include Car Emissions in Totals',
  dataAt: 'CarbonEmissionSetting.IncludeCarEmissionsInTotals',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: 'This option will include car emissions to be included in booking totals',
  prerequisiteFor: ['CarbonEmissionSetting.EnableEmissionsTotal']
}

const EnableHotelEmissions = {
  displayName: 'Enable Hotel Emissions',
  dataAt: 'CarbonEmissionSetting.EnableHotelEmissions',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: 'This option will enable hotel CO2 emissions to display',
  prerequisiteFor: ['CarbonEmissionSetting.IncludeHotelEmissionsInTotals']
}

const IncludeHotelEmissionsInTotals = {
  displayName: 'Include Hotel Emissions in Totals',
  dataAt: 'CarbonEmissionSetting.IncludeHotelEmissionsInTotals',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: 'This option will include hotel emissions to be included in booking totals',
  prerequisiteFor: ['CarbonEmissionSetting.EnableEmissionsTotal']
}

const EnableOptionalOffset = {
  displayName: 'Enable Optional Offset',
  dataAt: 'CarbonEmissionSetting.EnableOptionalOffset',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: 'This option will enable optional to Offset CO2 emissions',
}

const EnableEmissionsTotal = {
  displayName: 'Enable Emissions Total',
  dataAt: 'CarbonEmissionSetting.EnableEmissionsTotal',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: 'This option will enable a Total Emission value to display',
  disableIfAllFalse: ['CarbonEmissionSetting.IncludeAirEmissionsInTotals', 'CarbonEmissionSetting.IncludeHotelEmissionsInTotals', 'CarbonEmissionSetting.IncludeCarEmissionsInTotals'],
  prerequisiteFor: ['CarbonEmissionSetting.EnableOptionalOffset', 'CarbonEmissionSetting.CarbonOffsetCostPerKg', 'CarbonEmissionSetting.CarbonOffsetProgramName', 'CarbonEmissionSetting.CarbonAdditionalInformationUrl']

}

const CarbonOffsetCostPerKG = {
  displayName: 'Carbon Offset Cost per KG',
  dataAt: 'CarbonEmissionSetting.CarbonOffsetCostPerKg',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number',
  helpText: 'This is the rate the debtor pays per kg of CO2',
  required: true
}

const CarbonOffsetProgramName = {
  displayName: 'Carbon Offset Program Name',
  dataAt: 'CarbonEmissionSetting.CarbonOffsetProgramName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: 'This is the Carbon Offset Program Name',
}

const CarbonAdditionalInformationUrl = {
  displayName: 'Additional Information URL',
  dataAt: 'CarbonEmissionSetting.CarbonAdditionalInformationUrl',
  displayAs: constants.DISPLAY_AS.URL,
  helpText: 'This is the Carbon Additional Information URL',
}

const DebtorAddSegmentsEnabled = {
  displayName: 'Enable Add Segments',
  dataAt: 'DebtorAddSegmentFeature',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: 'Enable Lightning Add Segment feature for this debtor'
};

const DebtorAddSegmentsSettingsGroup = {
  displayName: 'Add Segment Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorAddSegmentsEnabled,
    CommonGroupSpacer],
  helpText: ''
};


const EmissionsSpacer = {
  displayAs: constants.DISPLAY_AS.SPACER,
}

const CarbonEmissionSettings = {
  displayAs: constants.DISPLAY_AS.GROUP,
  displayName: 'Carbon Emissions',
  children: [
    EmissionsSpacer, EnableAirEmissions, IncludeAirEmissionsInTotals,
    EmissionsSpacer, EnableCarEmissions, IncludeCarEmissionsInTotals,
    EmissionsSpacer, EnableHotelEmissions, IncludeHotelEmissionsInTotals,
    EmissionsSpacer, EnableEmissionsTotal,
    EmissionsSpacer, EnableOptionalOffset,
    EmissionsSpacer, CarbonOffsetCostPerKG, CarbonOffsetProgramName, CarbonAdditionalInformationUrl
  ]
}

const DebtorAgencyChangeFeesItem = {
  displayName: 'Agency Change Fees Item',
  dataAt: 'AgencyChangeFees.$debAgChangeFeesItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorAgencyChangeFeesName, DebtorAgencyChangeFeesAmount, DebtorAgencyChangeFeesCountries, DebtorAgencyChangeFeesServiceFeeCode],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debAgChangeFeesItem',
  canDelete: true
};

const ReasonForChangeTitle = {
  displayName: 'Title',
  dataAt: 'ReasonsForChange.$debReasonChangeItem.Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ReasonForChangeCode = {
  displayName: 'Code',
  dataAt: 'ReasonsForChange.$debReasonChangeItem.Code',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};


const ReasonForChangeItem = {
  displayName: 'Reason For Change Item',
  dataAt: 'ReasonsForChange.$debReasonChangeItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ReasonForChangeTitle, ReasonForChangeCode],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debReasonChangeItem',
  canDelete: true
};

const DebtorGdsItem = {
  displayName: 'Gds Item',
  dataAt: 'Gds.$GdsItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorGdsName, DebtorGdsEnabled, DebtorGdsSettings, DebtorGdsMiQuestions, DebtorGdsCorporateIdentifiers, DebtorGdsSupplierConfiguration, DebtorGdsHotelAggregatorConfiguration],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'GdsItem',
  canDelete: true
};

const HotelConfigurationPaymentNarrativesItem = {
  displayName: 'Hotel Payment Narrative',
  dataAt: 'HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [HotelConfigurationPaymentNarrativesPaymentCode, HotelConfigurationPaymentNarrativesPaymentNarrative, HotelConfigurationPaymentNarrativesPaymentInstructions, HotelConfigurationPaymentNarrativesServiceFeeCode, HotelConfigurationPaymentNarrativesProviders, HotelConfigurationPaymentNarrativesAggregatorTypes, HotelConfigurationPaymentNarrativesIsDomesticOnly],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'hotConPaymentNarrativesItem',
  canDelete: true
};

const HotelConfigurationRadiusCitiesItem = {
  displayName: 'City Radius',
  dataAt: 'HotelConfiguration.Radius.Cities.$hotConRadCitiesItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [HotelConfigurationRadiusCitiesCityCode, HotelConfigurationRadiusCitiesRadius],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'hotConRadCitiesItem',
  canDelete: true
};

const RailSupplierSettingsItem = {
  displayName: 'Item',
  dataAt: 'RailConfiguration.RailSupplierSettings.$railSuppSettingItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [RailSupplierSettingsName, RailSupplierSettingsCode, RailSupplierSettingsSettings],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'railSuppSettingItem',
  canDelete: true
};

const FlightSearchWindowItem = {
  displayName: 'Flight Search Window',
  dataAt: 'FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [FlightSearchWindowsIsAllDaySearch, FlightSearchWindowsFlightSearchWindowFrom, FlightSearchWindowsFlightSearchWindowTo, FlightSearchWindowsFlightPolicyDepartureWindowFrom, FlightSearchWindowsFlightPolicyDepartureWindowTo, FlightSearchWindowsOrigins, FlightSearchWindowsDestinations],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'flightSearchWindowItem',
  canDelete: true
};

const CombinableFareRulesItem = {
  displayName: 'Combinable Fare Rule',
  dataAt: 'FlightConfiguration.CombinableFareRules.$combFareRulesItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [CombinableFareRulesOrigin, CombinableFareRulesDestination],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'combFareRulesItem',
  canDelete: true
};

const OneWayFareRulesItem = {
  displayName: 'One Way Fare Rule',
  dataAt: 'FlightConfiguration.OneWayFareRules.$oneWayFarRuItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [OneWayFareRulesOrigin, OneWayFareRulesDestination],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'oneWayFarRuItem',
  canDelete: true
};

const PaymentConfigurationsItem = {
  displayName: 'Payment Configuration',
  dataAt: 'PaymentConfigurations.$payConItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [PaymentConfigurationsProvider, PaymentConfigurationsPaymentTypes],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'payConItem',
  canDelete: true
};

const VirtualCreditCardConfigurationsItem = {
  displayName: 'Virtual Credit Card Configuration',
  dataAt: 'VirtualCreditCardConfigurations.$vccConfigItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [VirtualCreditCardConfigurationsCardPoolId, VirtualCreditCardConfigurationsCardIssuer,
    VirtualCreditCardConfigurationsCardCode, VirtualCreditCardConfigurationsAgentId, VirtualCreditCardConfigurationsCardProvider,
    VirtualCreditCardConfigurationsCardSegmentTypes, VirtualCreditCardConfigurationsCardAggregatorTypes,
    VirtualCreditCardConfigurationsCardIssuerEnhancedDataMappings, VirtualCreditCardConfigurationsCardDisplayName],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'vccConfigItem',
  canDelete: true
}

const DebtorAgencyReasonCodesItem = {
  displayName: 'Agency Reason Codes Item',
  dataAt: 'DebtorAgencyReasonCodes.$debAgReCoItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorAgencyReasonCodesCode, DebtorAgencyReasonCodesTitle],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debAgReCoItem',
  canDelete: true
};

const AgencyCreditCardsItem = {
  displayName: 'Agency Credit Card',
  dataAt: 'DebtorAgencyCreditCards.$debtAgCCItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [AgencyCreditCardsItemTitle, AgencyCreditCardsItemId, CreditCardId, CreditCardProvider, SegmentTypes, AgencyCreditCardsItemCreatedBy, AgencyCreditCardsItemCreatedOn, AgencyCreditCardsItemModifiedBy, AgencyCreditCardsItemModifiedOn],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debtAgCCItem',
  canDelete: true
};

const CompanyReferencesGridItem = {
  displayName: 'Company References',
  dataAt: 'CompanyReferences.$compRefItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [CompanyReferencesCode, CompanyReferencesTitle, CompanyReferencesOptions, CompanyReferencesFlags, CompanyReferencesMandatory, CompanyReferencesSort, CompanyReferencesChildren],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'compRefItem',
  canDelete: true
};

const ItineraryPoliciesItem = {
  displayName: 'Itinerary Policy',
  dataAt: 'ItineraryPolicies',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [ItineraryPoliciesCode, ItineraryPoliciesTitle, ItineraryPoliciesCountries, ItineraryPoliciesApprovalLevel, ItineraryPoliciesBreakPolicyEscalationApprovalLevel, ItineraryPoliciesApprovalTiers, ItineraryPoliciesReasonsForTravel, ItineraryPoliciesTabs],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'ItinPolIndex',
  canDelete: true
};

const DebtorApproversItem = {
  displayName: 'Debtor Approver',
  dataAt: 'DebtorApprovers',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorApproversFirstName, DebtorApproversLastName, DebtorApproversEmail, DebtorApproversCostCentres, DebtorApproversDepartments, DebtorApproversTravellers, DebtorApproversPolicyCodeTiers, DebtorApproversEnabled],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debtorApproversIndex',
  canDelete: true
};

const DebtorTermsAndConditionsItem = {
  displayName: 'Item',
  dataAt: 'TermsAndConditions',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [TermsAndConditionsCountries, TermsAndConditionsSegmentTypes, TermsAndConditionsText],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debtorTermsItem',
  canDelete: true
};

const DebtorOrderNumberCodesItem = {
  displayName: 'Debtor Order Number Codes',
  dataAt: 'DebtorOrderNumberCodes',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [DebtorOrderNumberCodesCode, DebtorOrderNumberCodesTitle],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'debtorOrderNumberCodesIndex',
  canDelete: true
};

const ModifiedOn = {
  displayName: 'Modified on',
  dataAt: 'ModifiedOn',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ModifiedBy = {
  displayName: 'Modified by',
  dataAt: 'ModifiedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CreatedOn = {
  displayName: 'Created on',
  dataAt: 'CreatedOn',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CreatedBy = {
  displayName: 'Created by',
  dataAt: 'CreatedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const TramadaConfigurationGlobalAPI = {
  displayName: 'Global API Profiles Enabled',
  dataAt: 'TramadaConfiguration.GlobalApiProfilesEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const TramadaConfigurationDatabase = {
  displayName: 'Tramada Configuration Database',
  dataAt: 'TramadaConfiguration.Database',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const TramadaConfigurationDebtorAuthCode = {
  displayName: 'Tramada Configuration Debtor Auth Code',
  dataAt: 'TramadaConfiguration.DebtorAuthCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const TramadaConfigurationDebtorId = {
  displayName: 'Tramada Configuration Debtor Id',
  dataAt: 'TramadaConfiguration.DebtorId',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const TramadaConfigurationAgencyId = {
  displayName: 'Tramada Configuration Agency Id',
  dataAt: 'TramadaConfiguration.AgencyId',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const TeamRejectionQueue = {
  displayName: 'Team Rejection Queue',
  dataAt: 'SabreConfiguration.TeamRejectionQueue',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const PccCity = {
  displayName: 'Pcc City',
  dataAt: 'SabreConfiguration.PccCity',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const Pcc = {
  displayName: 'Pcc',
  dataAt: 'SabreConfiguration.Pcc',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AutoTicketingQueue = {
  displayName: 'Auto Ticketing Queue',
  dataAt: 'SabreConfiguration.AutoTicketingQueue',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const AuthorisationHoldQueue = {
  displayName: 'Authorisation Hold Queue',
  dataAt: 'SabreConfiguration.AuthorisationHoldQueue',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const NdcSabreQueue = {
  displayName: 'NDC Sabre Queue',
  dataAt: 'SabreConfiguration.NdcSabreQueue',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const NdcQueueEmail = {
  displayName: 'NDC Queue Email',
  dataAt: 'SabreConfiguration.NdcQueueEmail',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const PostBookingChangesQueue = {
  displayName: 'Post Booking Changes Queue',
  dataAt: 'SabreConfiguration.PostBookingChangesQueue',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const PostBookingChangesEmail = {
  displayName: 'Post Booking Changes Email',
  dataAt: 'SabreConfiguration.PostBookingChangesEmail',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};


const DebtorGds = {
  displayName: 'Gds',
  dataAt: 'Gds',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorGdsItem,
  gridCols:
    [{ name: 'Name', key: 'Name' },
    { name: 'Enabled', key: 'Enabled' }]
};

const DebtorAgencyChangeFees = {
  displayName: 'Agency Change Fees',
  dataAt: 'AgencyChangeFees',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorAgencyChangeFeesItem,
  gridCols:
    [{ name: 'Name', key: 'Name' },
    { name: 'Amount', key: 'Amount' },
    { name: 'Countries', key: 'Countries' }]
};

const ReasonsForChanges = {
  displayName: 'Reasons For Change',
  dataAt: 'ReasonsForChange',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ReasonForChangeItem,
  gridCols:
    [{ name: 'Title', key: 'Title' },
    { name: 'Code', key: 'Code' }]
};

const DebtorLimitCountries = {
  displayName: 'Limit Countries',
  dataAt: 'LimitCountries',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const HotelRateToleranceMin = {
  displayName: 'Minimum amount',
  dataAt: 'HotelConfiguration.HotelRateTolerance.Minimum',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const DebtorBeamerEnabled = {
  displayName: 'Enable Beamer',
  dataAt: 'DebtorBeamerFeature',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: 'Enable Lightning Beamer feature for this debtor'
};

const DebtorBeamerSettingsGroup = {
  displayName: 'Beamer Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: '',
  children: [
    DebtorBeamerEnabled,
    CommonGroupSpacer],
  helpText: 'Debtor level Beamer config'
};

const HotelRateToleranceMax = {
  displayName: 'Maximum amount',
  dataAt: 'HotelConfiguration.HotelRateTolerance.Maximum',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const HotelRateToleranceEnabled = {
  displayName: 'Hotel Rate Tolerance',
  dataAt: 'HotelConfiguration.HotelRateTolerance.Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: 'Enable Hotel Tolerance Filter to apply for this debtor. This will filter out Expedia and Booking.com rates, if returned from the hotel search results within the specified price tolerance'
};


const HotelConfigurationTags = {
  displayName: 'Hotel Tagging',
  dataAt: 'HotelConfiguration.Tags',
  displayAs: constants.DISPLAY_AS.HOTEL_TAG_SELECT
};

const HotelConfigurationPaymentNarratives = {
  displayName: 'Hotel Payment Narratives',
  dataAt: 'HotelConfiguration.PaymentNarratives',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: HotelConfigurationPaymentNarrativesItem,
  gridCols:
    [{ name: 'Payment Narrative', key: 'PaymentNarrative' },
    { name: 'Providers', key: 'Providers' },
    { name: 'Aggregator', key: 'AggregatorTypes' },
    { name: 'Is Domestic Only', key: 'IsDomesticOnly' }]
};

const HotelConfigurationRadiusCities = {
  displayName: 'Cities',
  dataAt: 'HotelConfiguration.Radius.Cities',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: HotelConfigurationRadiusCitiesItem,
  gridCols:
    [{ name: 'CityCode', key: 'CityCode' },
    { name: 'Radius', key: 'Radius' }]
};

const HotelConfigurationRadiusDefaultRadius = {
  displayName: 'Default Radius (defaults to kilometers unless imperial system is checked)',
  dataAt: 'HotelConfiguration.Radius.DefaultRadius',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'HotelConfigurationRadius',
  optionsNumbers: true,
  required: false
};

const HotelConfigurationEnableOvernightHotelPrompt = {
  displayName: 'Enable Overnight Hotel Prompt',
  dataAt: 'HotelConfiguration.EnableOvernightHotelPrompt',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const HotelConfigurationDisableRecommendedRankings = {
  displayName: 'Disable the CTM hotel recommended rankings',
  dataAt: 'HotelConfiguration.DisableHotelRecommendedRankings',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const RailSupplierSettings = {
  displayName: 'Rail Supplier Settings',
  dataAt: 'RailConfiguration.RailSupplierSettings',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: RailSupplierSettingsItem,
  gridCols: [{ name: 'Name', key: 'Name' }, { name: 'Code', key: 'Code' }]
};

const CarConfigurationBillingReferenceEnabled = {
  displayName: 'Billing Reference Enabled',
  dataAt: 'CarConfiguration.BillingReferenceEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const CarConfigurationBillingReferenceMandatory = {
  displayName: 'Billing Reference Mandatory',
  dataAt: 'CarConfiguration.BillingReferenceMandatory',
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const RailConfiguration = {
  displayName: 'Rail Enabled',
  dataAt: 'RailConfiguration.Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const FlightConfigurationRiskEngineFlightThresholdLimit = {
  displayName: 'Risk Engine Flight Threshold Limit',
  dataAt: 'FlightConfiguration.RiskEngineFlightThresholdLimit',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'number'
};

const FlightSearchWindows = {
  displayName: 'Flight Search Windows',
  dataAt: 'FlightConfiguration.FlightWindowSettings',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: FlightSearchWindowItem,
  gridCols:
    [{ name: 'Origins', key: 'Origins' },
    { name: 'Destinations', key: 'Destinations' }]
};

const CombinableFareRules = {
  displayName: 'Combinable Fare Rules',
  dataAt: 'FlightConfiguration.CombinableFareRules',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CombinableFareRulesItem,
  gridCols:
    [{ name: 'Origin', key: 'Origin' },
    { name: 'Destination', key: 'Destination' }]
};

const OneWayFareRules = {
  displayName: 'One Way Fare Rules',
  dataAt: 'FlightConfiguration.OneWayFareRules',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: OneWayFareRulesItem,
  gridCols:
    [{ name: 'Origin', key: 'Origin' },
    { name: 'Destination', key: 'Destination' }]
};

const FlightPolicyDepatureWindowTo = {
  displayName: 'Depature Window To',
  dataAt: 'FlightConfiguration.FlightPolicyDepatureWindowTo',
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 15,
  max: 720,
  step: 15,
  divideResultBy: 60,
  units: 'minutes'
};

const FlightPolicyDepatureWindowFrom = {
  displayName: 'Depature Window From',
  dataAt: 'FlightConfiguration.FlightPolicyDepatureWindowFrom',
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 15,
  max: 720,
  step: 15,
  divideResultBy: 60,
  units: 'minutes'
};

const PaymentConfigurations = {
  displayName: 'Payment Configurations',
  dataAt: 'PaymentConfigurations',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: PaymentConfigurationsItem,
  gridCols: [{ name: 'Provider', key: 'Provider' }]
};

const VirtualCreditCardConfigurations = {
  displayName: 'Virtual Credit Card Configurations',
  dataAt: 'VirtualCreditCardConfigurations',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: VirtualCreditCardConfigurationsItem,
  gridCols: [{ name: 'Card Pool Id', key: 'CardPoolId' },
  { name: 'Card Issuer', key: 'CardIssuer' },
  { name: 'Card Code', key: 'CardCode' },
  { name: 'AgentId', key: 'AgentId' },
  { name: 'Supplier', key: 'Provider' },
  { name: 'Segment Types', key: 'SegmentTypes' },
  { name: 'Card Display Name', key: 'CardDisplayName' }]
};

const DebtorAgencyPostcode = {
  displayName: 'Agency Postcode',
  dataAt: 'DebtorAgency.Postcode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAgencyState = {
  displayName: 'Agency State',
  dataAt: 'DebtorAgency.State',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAgencyCity = {
  displayName: 'Agency City',
  dataAt: 'DebtorAgency.City',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAgencyStreet = {
  displayName: 'Agency Street',
  dataAt: 'DebtorAgency.Street',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAgencyAddress = {
  displayName: 'Agency Address',
  dataAt: 'DebtorAgency.Address',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAgencyReasonCodes = {
  displayName: 'Agency Reason Codes',
  dataAt: 'DebtorAgencyReasonCodes',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorAgencyReasonCodesItem,
  gridCols:
    [{ name: 'Code', key: 'Code' },
    { name: 'Title', key: 'Title' }],
  excelExport: {
    fileName: 'Debtor - Agency Reason Codes',
    arrayParentRef: {
      name: 'Code',
      dataAt: 'Code'
    },
    cols: [
      {
        name: 'Code',
        dataAt: 'Code'
      },
      {
        name: 'Title',
        dataAt: 'Title'
      }
    ]
  }
};

const AgencyReasonDisplayName = {
  displayName: 'Reason for travel display name',
  dataAt: 'AgencyReasonDisplayName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AgencyCreditCards = {
  displayName: 'Agency Credit Cards',
  dataAt: 'DebtorAgencyCreditCards',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: AgencyCreditCardsItem,
  gridCols:
    [{ name: 'Title', key: 'Title' },
    { name: 'Credit Card Id', key: 'CreditCardId' },
    { name: 'Supplier', key: 'Provider' }]
};

const CompanyReferencesGrid = {
  displayName: 'Company References',
  dataAt: 'CompanyReferences',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CompanyReferencesGridItem,
  gridCols:
    [{ name: 'Code', key: 'Code' },
    { name: 'Title', key: 'Title' },
    { name: 'Mandatory', key: 'Mandatory' },
    { name: 'Sort', key: 'Sort' }],
  excelExport: {
    fileName: 'Company References',
    arrayParentRef: {
      name: 'Code',
      dataAt: 'Code'
    },
    disableImport: true,
    cols: [
      {
        name: 'Code',
        dataAt: 'Code'
      },
      {
        name: 'Title',
        dataAt: 'Title'
      },
      {
        name: 'Options',
        dataAt: 'Options',
        commaSeparateArray: true,
      },
      {
        name: 'Flags',
        dataAt: 'Flags',
        commaSeparateArray: true,
      },
      {
        name: 'Mandatory',
        dataAt: 'Mandatory',
        isBoolean: true
      },
      {
        name: 'Sort',
        dataAt: 'Sort'
      }
    ]
  }
};

const ItineraryPolicies = {
  displayName: 'Itinerary Policies',
  dataAt: 'ItineraryPolicies',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ItineraryPoliciesItem,
  gridCols:
    [{ name: 'Code', key: 'Code' },
    { name: 'Title', key: 'Title' },
    { name: 'Employee Type', key: 'Items' },
    { name: 'Countries', key: 'Countries' },
    { name: 'Reason for Travel', key: 'ReasonsForTravel' },
    { name: 'Approval Level', key: 'ApprovalLevel' }]
};

const DebtorApproverFileDownloader = {
  displayName: 'Approver File Download',
  dataAt: 'DebtorApproverFileDownloader',
  displayAs: constants.DISPLAY_AS.FILE_DOWNLOADER,
  fileNameSuffix: 'Approvers.xlsx',
  parameterValueFromActiveItemProperty: 'Name',
  parameterName: 'debtorIdentifier',
  endPointController: 'DebtorApproverDownload'
};

const DebtorApproverFileUpload = {
  displayName: 'Approver File Upload',
  dataAt: 'DebtorApproverFileUpload',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'DebtorApproverBatchUpload',
  uploadType: 'xlsx',
  fileNamePrefixProperty: 'Name',
  fileNameFormat: 'yyyymmdd',
  excludeFromPost: true
};

const DebtorApprovers = {
  displayName: 'Debtor Approvers',
  dataAt: 'DebtorApprovers',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorApproversItem,
  gridCols:
    [{ name: 'First Name', key: 'FirstName' },
    { name: 'Last Name', key: 'LastName' },
    { name: 'Email', key: 'Email' }]
};

const ReminderEmails = {
  displayName: 'Reminder Emails',
  dataAt: 'ReminderEmails',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const RestrictSelfApproval = {
  displayName: 'Restrict Self Approval',
  dataAt: 'RestrictSelfApproval',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const DebtorApprovalsCommentEnabled = {
  displayName: 'Free Format Approval Reason',
  dataAt: 'Approvals.Comment.Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const DebtorBookingConfirmationWebHookUrl = {
  displayName: 'Booking Confirmation Web Hook',
  dataAt: 'BookingConfirmationWebhookUrl',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const BreakPolicyEscalationApprovalLevel = {
  displayName: 'Break Policy Escalation Approval Level',
  dataAt: 'BreakPolicyEscalationApprovalLevel',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'approvalLevels'
};

const DebtorApprovalLevel = {
  displayName: 'Debtor Approval Level',
  dataAt: 'DebtorApprovalLevel',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'approvalLevels'
};

const DoNotShowApprovalTabs = {
  displayName: 'Do not show the Approval Tabs on the Manage Bookings page',
  dataAt: 'Approvals.DoNotShowApprovalTabs',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: 'This controls the display of the approval related tabs on the Manage Bookings page'
};

const DebtorTermsAndConditions = {
  displayName: 'Terms and Conditions',
  dataAt: 'TermsAndConditions',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorTermsAndConditionsItem,
  gridCols:
    [{ name: 'Countries', key: 'Countries' },
    { name: 'SegmentTypes', key: 'SegmentTypes' }]
};

const TravellerConfigurationGuestTravellerProfileName = {
  displayName: 'Traveller Configuration Guest Profile Name',
  dataAt: 'TravellerConfiguration.GuestTravellerProfileName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const TravellerConfigurationPcc = {
  displayName: 'Traveller Configuration Pcc',
  dataAt: 'TravellerConfiguration.Pcc',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const TravellerConfigurationSource = {
  displayName: 'Traveller Configuration Source',
  dataAt: 'TravellerConfiguration.Source',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'TravellerConfigurationSources'
};

const PointsOfInterestFileUploader = {
  displayName: 'Points Of Interest File Upload',
  dataAt: 'PointsOfInterestFile',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'PointOfInterestBatchUpload',
  uploadType: 'xlsx',
  fileNamePrefixProperty: 'Name',
  fileNameSuffix: '_poi_import',
  fileNameFormat: 'yyyymmdd',
  excludeFromPost: true
};

const PostBookingChangeRemarks = {
  displayName: 'Post Booking Changes Remarks',
  dataAt: 'PostBookingChangesRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const HostCommands = {
  displayName: 'Host Commands',
  dataAt: 'HostCommands',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const HomeCountryCode = {
  displayName: 'Home Country Code',
  dataAt: 'HomeCountryCode',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single'
};

const DebtorOrderNumberCodes = {
  displayName: 'Debtor Order Number Codes',
  dataAt: 'DebtorOrderNumberCodes',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorOrderNumberCodesItem,
  gridCols:
    [{ name: 'Code', key: 'Code' },
    { name: 'Title', key: 'Title' }]
};

const AdditionalPnrRemarks = {
  displayName: 'Additional Pnr Remarks',
  dataAt: 'AdditionalPnrRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const TaxiPnrRemarks = {
  displayName: 'Taxi Pnr Remarks',
  dataAt: 'TaxiPnrRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const ExclusionRemarks = {
  displayName: 'Exclusion Remarks',
  dataAt: 'ExclusionRemarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const ApprovalRemarksExclusions = {
  displayName: 'Approval Remarks Exclusions',
  dataAt: 'ApprovalRemarks.Exclusions',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const ApprovalRemarks = {
  displayName: 'Approval Remarks',
  dataAt: 'ApprovalRemarks.Remarks',
  displayAs: constants.DISPLAY_AS.REMARKS_EDITOR
};

const ProfileCompanySize = {
  displayName: 'Profile Company Size (no. of people)',
  dataAt: 'Profile.CompanySize',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ProfileIndustry = {
  displayName: 'Profile Industry',
  dataAt: 'Profile.Industry',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ProfileAfterHoursPhoneNumber = {
  displayName: 'Profile After Hours Phone Number',
  dataAt: 'Profile.AfterHoursPhoneNumber',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ProfileDaytimePhoneNumber = {
  displayName: 'Profile Daytime Phone Number',
  dataAt: 'Profile.DaytimePhoneNumber',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ProfileCompanyIdentifier = {
  displayName: 'Profile Company Identifier (Business number)',
  dataAt: 'Profile.CompanyIdentifier',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAddressCountryCode = {
  displayName: 'Debtor Address Country Code',
  dataAt: 'DebtorAddress.CountryCode',
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: 'single'
};

const DebtorAddressPostcode = {
  displayName: 'Debtor Address Postcode',
  dataAt: 'DebtorAddress.Postcode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAddressState = {
  displayName: 'Debtor Address State',
  dataAt: 'DebtorAddress.State',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAddressCityCode = {
  displayName: 'Debtor Address City Code',
  dataAt: 'DebtorAddress.CityCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAddressCity = {
  displayName: 'Debtor Address City',
  dataAt: 'DebtorAddress.City',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAddressStreet = {
  displayName: 'Debtor Address Street',
  dataAt: 'DebtorAddress.Street',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAddressAddress = {
  displayName: 'Debtor Address',
  dataAt: 'DebtorAddress.Address',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAddressLastname = {
  displayName: 'Debtor Address Last name',
  dataAt: 'DebtorAddress.Lastname',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorAddressFirstname = {
  displayName: 'Debtor Address First name',
  dataAt: 'DebtorAddress.Firstname',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const DebtorSupportCurrencyCode = {
  displayName: 'Debtor Support Currency Code',
  dataAt: 'DebtorSupport.CurrencyCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const DebtorSupportEmailAddress = {
  displayName: 'Debtor Support Email',
  dataAt: 'DebtorSupport.EmailAddress',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'email',
  required: true
};

const DebtorSupportPhoneNumber = {
  displayName: 'Debtor Support Phone Number',
  dataAt: 'DebtorSupport.PhoneNumber',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const PaymentMethodSelectionMandatory = {
  displayName: 'Payment Method Selection Mandatory',
  dataAt: 'PaymentMethodSelectionMandatory',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const DepartmentEnabled = {
  displayName: 'Change Department',
  dataAt: 'Department.Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const DepartmentMandatory = {
  displayName: 'Department Mandatory',
  dataAt: 'Department.Mandatory',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const CostCentreEnabled = {
  displayName: 'Change Cost Centre',
  dataAt: 'CostCentre.Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const CostCentreMandatory = {
  displayName: 'Cost Centre Mandatory',
  dataAt: 'CostCentre.Mandatory',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const OrderNumberDisplayName = {
  displayName: 'Order Number Display Name',
  dataAt: 'OrderNumberDisplayName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const OrderNumberEnabled = {
  displayName: 'Order Number Enabled',
  dataAt: 'OrderNumberEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const OrderNumberMandatory = {
  displayName: 'Order Number Mandatory',
  dataAt: 'OrderNumberMandatory',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const GuestTraveller = {
  displayName: 'Guest Traveller Enabled',
  dataAt: 'GuestTraveller.Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const Disabled = {
  displayName: 'Disabled',
  dataAt: 'Disabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const SctNewBookingsEnabled = {
  displayName: 'SCT New Bookings Enabled',
  dataAt: 'SctNewBookingsEnabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const TravelArrangersCanOnlyViewBookingsTheyHaveMade = {
  displayName: 'Manage Bookings - Travel Arrangers only view bookings they have made',
  dataAt: 'TravelArrangersCanOnlyViewBookingsTheyHaveMade',
  displayAs: constants.DISPLAY_AS.SWITCH,
  helpText: 'This will override the existing viewing permissions on the Manage Bookings page and Travel Arrangers will only be able to view bookings they have made'
};

const Title = {
  displayName: 'Title',
  dataAt: 'Title',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const Logo = {
  displayName: 'Logo url',
  dataAt: 'LogoUrl',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'DebtorLogo',
  uploadType: 'image'
};

const Id = {
  displayName: 'Identifier',
  dataAt: 'Id',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const AdminPanel = {
  tabName: 'Admin',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [CreatedBy, CreatedOn, ModifiedBy, ModifiedOn]
};

const TramadaConfigurationPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Tramada',
  children: [TramadaConfigurationAgencyId, TramadaConfigurationDebtorId, TramadaConfigurationDebtorAuthCode, TramadaConfigurationDatabase, TramadaConfigurationGlobalAPI]
};

const PNRRemarksPanel = {
  dataAt: '',
  tabName: 'PNR-Remarks',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [AdditionalPnrRemarks, TaxiPnrRemarks, HostCommands, ExclusionRemarks, ApprovalRemarksExclusions, ApprovalRemarks, PostBookingChangeRemarks, AgencyServiceFeeRemarks, CancellationRemarks, SegmentCancellationRemarks]
};

const GDSPanel = {
  dataAt: '',
  tabName: 'GDS',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [DebtorGds, AuthorisationHoldQueue, AutoTicketingQueue, Pcc, PccCity, TeamRejectionQueue, NdcSabreQueue, NdcQueueEmail, PostBookingChangesQueue, PostBookingChangesEmail]
};

const AllSectorConfigPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'All-Sectors',
  children: [DebtorLimitCountries, ReasonsForChanges, DebtorAgencyChangeFees, DebtorBeamerSettingsGroup, CarbonEmissionSettings, DebtorAddSegmentsSettingsGroup]
};

const HotelConfigurationPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Hotel-Sectors',
  children: [HotelConfigurationEnableOvernightHotelPrompt, HotelConfigurationIsImperialSystem, HotelConfigurationDisableRecommendedRankings, HotelConfigurationRadiusDefaultRadius, HotelConfigurationRadiusCities, HotelConfigurationPaymentNarratives, HotelConfigurationTags, HotelRateToleranceEnabled, HotelRateToleranceMin, HotelRateToleranceMax]
};

const RailConfigPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Rail-Sectors',
  children: [RailConfiguration, RailSupplierSettings]
};

const FlightConfigPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Flight-Sectors',
  children: [FlightPolicyDepatureWindowFrom, FlightPolicyDepatureWindowTo, OneWayFareRules, CombinableFareRules, FlightSearchWindows, FlightConfigurationRiskEngineFlightThresholdLimit]
};

const CarConfigPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Car-Sectors',
  children: [CarConfigurationBillingReferenceEnabled, CarConfigurationBillingReferenceMandatory]
};

const Agency = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Agency',
  children: [AgencyCreditCards, AgencyReasonDisplayName, DebtorAgencyReasonCodes, DebtorAgencyAddress, DebtorAgencyStreet, DebtorAgencyCity, DebtorAgencyState, DebtorAgencyPostcode, PaymentConfigurations, VirtualCreditCardConfigurations]
};

const CompanyReferencesPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Company-References',
  children: [CompanyReferencesGrid]
};

const NDCPNRRemarksRemarks = {
  displayName: 'Remarks',
  dataAt: 'ServiceFeeRemarks.$ndcPnrRemarksItem.Remark',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const NDCPNRRemarksDisplayName = {
  displayName: 'Display Name',
  dataAt: 'ServiceFeeRemarks.$ndcPnrRemarksItem.DisplayName',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const NDCPNRRemarksGridItem = {
  displayName: 'NDC PNR Remarks',
  dataAt: 'ServiceFeeRemarks.$ndcPnrRemarksItem',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [NDCPNRRemarksDisplayName, NDCPNRRemarksRemarks],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'ndcPnrRemarksItem',
  canDelete: true
};

const NDCPNRRemarksGrid = {
  displayName: 'NDC Servicing Utility Service Fee Remarks',
  dataAt: 'ServiceFeeRemarks',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: NDCPNRRemarksGridItem,
  gridCols:
    [{ name: 'Display Name', key: 'DisplayName' },
    { name: 'Remark', key: 'Remark' }]
};

const NDCPNRRemarksPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'NDC-PNR-Remarks',
  children: [NDCPNRRemarksGrid]
};

const PoliciesPanel = {
  tabName: 'Policies',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ItineraryPolicies]
};

const ApprovalsPanel = {
  tabName: 'Approvals',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [DebtorApprovalLevel, BreakPolicyEscalationApprovalLevel, DebtorBookingConfirmationWebHookUrl, DebtorApprovalsCommentEnabled, RestrictSelfApproval, ReminderEmails, DebtorApprovers, DebtorApproverFileUpload, DebtorApproverFileDownloader, DoNotShowApprovalTabs]
};

const ConsultingTeamEmail = {
  displayName: 'Consulting Team Email',
  dataAt: 'ConsultingTeamEmail',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: 'email'
};

const DebtorName = {
  displayName: 'Debtor Name',
  dataAt: 'Name',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
};

const InfoPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Info',
  children: [Id, Title, DebtorName, Logo, ConsultingTeamEmail, Disabled, SctNewBookingsEnabled, GuestTraveller, OrderNumberMandatory, OrderNumberEnabled, OrderNumberDisplayName, CostCentreMandatory, CostCentreEnabled, DepartmentMandatory, DepartmentEnabled, PaymentMethodSelectionMandatory, TravelArrangersCanOnlyViewBookingsTheyHaveMade, DebtorSupportPhoneNumber, DebtorSupportEmailAddress, DebtorSupportCurrencyCode, DebtorAddressFirstname, DebtorAddressLastname, DebtorAddressAddress, DebtorAddressStreet, DebtorAddressCity, DebtorAddressCityCode, DebtorAddressState, DebtorAddressPostcode, DebtorAddressCountryCode, ProfileCompanyIdentifier, ProfileDaytimePhoneNumber, ProfileAfterHoursPhoneNumber, ProfileIndustry, ProfileCompanySize, DebtorOrderNumberCodes, HomeCountryCode, PointsOfInterestFileUploader, TravellerConfigurationSource, TravellerConfigurationPcc, TravellerConfigurationGuestTravellerProfileName, DebtorTermsAndConditions]
};

const AllowFederationLogoutSetting = {
  displayName: 'Allow Federation logout outside listed client ip addresses',
  dataAt: 'AuthenticationConfig.EnableFederationLogout',
  displayAs: constants.DISPLAY_AS.BOOLEAN
}

const ClientIpAddressItem = {
  displayName: 'Item',
  dataAt: 'AuthenticationConfig.ClientIpAddresses.$clientIpAddr',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    {
      displayName: 'Rule name',
      dataAt: 'AuthenticationConfig.ClientIpAddresses.$clientIpAddr.Name',
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
      helpText: 'Name for this IP Address range'
    }, {
      displayName: 'Start IP',
      dataAt: 'AuthenticationConfig.ClientIpAddresses.$clientIpAddr.StartIpAddress',
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
      helpText: 'Start IP Address Range, if you need an IP range added in the format 140.15.3.85/24 please refer to <a href="https://www.ipaddressguide.com/cidr" target="_blank">this link</a> for support'
    },
    {
      displayName: 'End IP',
      dataAt: 'AuthenticationConfig.ClientIpAddresses.$clientIpAddr.EndIpAddress',
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
      helpText: 'End IP Address Range, if you need an IP range added in the format 140.15.3.85/24 please refer to <a href="https://www.ipaddressguide.com/cidr" target="_blank">this link</a> for support'
    }],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  removeParamId: 'clientIpAddr',
  canDelete: true
};


const ClientIpAddresses = {
  displayName: 'Client IP Addresses',
  dataAt: 'AuthenticationConfig.ClientIpAddresses',
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ClientIpAddressItem,
  gridCols:
    [{ name: 'Rule name', key: 'Name' },
    { name: 'Start IP', key: 'StartIpAddress' },
    { name: 'End IP', key: 'EndIpAddress' }]
};

const ConfigurableUiTimeoutSetting = {
  displayName: 'UI Auto Logout timesetting',
  dataAt: 'AuthenticationConfig.AutoLogoutInMinutes',
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 5,
  max: 480,
  step: 5,
  defaultValue: 60,
  units: 'minutes',
  helpText: 'User will be logged out if they are inactive for X minutes'
};

const AuthenticationConfigPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Authentication',
  children: [AzureTenantIds, SamlConnectionNames, ConfigurableUiTimeoutSetting, ClientIpAddresses, AllowFederationLogoutSetting]
};

const DebtorTabs = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.TABS,
  children: [InfoPanel, ApprovalsPanel, PoliciesPanel, CompanyReferencesPanel, Agency, FlightConfigPanel, RailConfigPanel, HotelConfigurationPanel, CarConfigPanel, AllSectorConfigPanel, GDSPanel, PNRRemarksPanel, NDCPNRRemarksPanel, TramadaConfigurationPanel, AuthenticationConfigPanel, UsersPanel, DebtorProductsPanel, AdminPanel]
};

const DebtorNameLabel = { dataAt: 'Name', displayAs: constants.DISPLAY_AS.SUB_HEADING, label: 'Name:' };

const DebtorAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Debtor',
  data:
  {
    Name: '',
    ConsultingTeamEmail: '',
    FlightConfiguration:
    {
      FlightPolicyDepatureWindowFrom: 3,
      FlightPolicyDepatureWindowTo: 3
    },
    HotelConfiguration: { Radius: { DefaultRadius: null } }
  },
  children: [DebtorName, ConsultingTeamEmail],
  endpoint: 'Debtors'
};

const Debtor = {
  displayName: 'Debtor',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  iconClass: 'fa-user',
  children: [DebtorNameLabel, DebtorTabs],
  endpoint: 'Debtors',
  routeParamId: 'debtorId',
  ODataArgs: '?$expand=DebtorProducts',
};

const DebtorList = {
  rootNode: true,
  displayName: 'Debtors',
  endpoint: 'Debtors',
  ODataArgs: '?$select=Id,Name,Title,HomeCountryCode,SabreConfiguration,Disabled',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: Debtor,
  gridAdd: DebtorAddResource,
  canCloneResource: true,
  canCloneResourceInputMessage: "Enter new debtor code?",
  excelExport: {
    disableImport: true,
    asyncLookup: false,
    fileName: 'debtors-export',
    excludeGeneratedId: true,
    cols: [
      {
        name: 'Name',
        dataAt: 'Name'
      },
      {
        name: 'Title',
        dataAt: 'Title'
      },
      {
        name: 'Home Country Code',
        dataAt: 'HomeCountryCode'
      },
      {
        name: 'Pcc',
        dataAt: 'SabreConfiguration.Pcc'
      },
      {
        name: 'Terminated',
        dataAt: 'Disabled'
      }]
  },
  iconClass: 'fa-user',
  gridCols:
    [{ name: 'Name', key: 'Name' },
    { name: 'Title', key: 'Title' },
    { name: 'Home Country Code', key: 'HomeCountryCode' },
    { name: 'Pcc', key: 'SabreConfiguration.Pcc' },
    { name: 'Terminated', key: 'Disabled' }]
};

export default {
  DebtorList,
  Debtor,
  DebtorAddResource,
  DebtorNameLabel,
  DebtorTabs,
  DebtorName,
  ConsultingTeamEmail,
  InfoPanel,
  ApprovalsPanel,
  PoliciesPanel,
  CompanyReferencesPanel,
  Agency,
  FlightConfigPanel,
  RailConfigPanel,
  HotelConfigurationPanel,
  CarConfigPanel,
  AllSectorConfigPanel,
  GDSPanel,
  PNRRemarksPanel,
  NDCPNRRemarksPanel,
  TramadaConfigurationPanel,
  AdminPanel,
  Id,
  Title,
  Logo,
  Disabled,
  SctNewBookingsEnabled,
  GuestTraveller,
  OrderNumberMandatory,
  OrderNumberEnabled,
  OrderNumberDisplayName,
  CostCentreMandatory,
  CostCentreEnabled,
  DepartmentMandatory,
  DepartmentEnabled,
  PaymentMethodSelectionMandatory,
  TravelArrangersCanOnlyViewBookingsTheyHaveMade,
  DebtorSupportPhoneNumber,
  DebtorSupportEmailAddress,
  DebtorSupportCurrencyCode,
  DebtorAddressFirstname,
  DebtorAddressLastname,
  DebtorAddressAddress,
  DebtorAddressStreet,
  DebtorAddressCity,
  DebtorAddressCityCode,
  DebtorAddressState,
  DebtorAddressPostcode,
  DebtorAddressCountryCode,
  ProfileCompanyIdentifier,
  ProfileDaytimePhoneNumber,
  ProfileAfterHoursPhoneNumber,
  ProfileIndustry,
  ProfileCompanySize,
  AdditionalPnrRemarks,
  TaxiPnrRemarks,
  ExclusionRemarks,
  ApprovalRemarksExclusions,
  ApprovalRemarks,
  DebtorOrderNumberCodes,
  HomeCountryCode,
  PostBookingChangeRemarks,
  HostCommands,
  PointsOfInterestFileUploader,
  TravellerConfigurationSource,
  TravellerConfigurationPcc,
  TravellerConfigurationGuestTravellerProfileName,
  DebtorTermsAndConditions,
  DebtorApprovalLevel,
  BreakPolicyEscalationApprovalLevel,
  DebtorBookingConfirmationWebHookUrl,
  DoNotShowApprovalTabs,
  DebtorApprovalsCommentEnabled,
  RestrictSelfApproval,
  ReminderEmails,
  DebtorApprovers,
  DebtorApproverFileUpload,
  DebtorApproverFileDownloader,
  ItineraryPolicies,
  CompanyReferencesGrid,
  NDCPNRRemarksGrid,
  AgencyCreditCards,
  AgencyReasonDisplayName,
  DebtorAgencyReasonCodes,
  DebtorAgencyAddress,
  DebtorAgencyStreet,
  DebtorAgencyCity,
  DebtorAgencyState,
  DebtorAgencyPostcode,
  PaymentConfigurations,
  VirtualCreditCardConfigurations,
  FlightPolicyDepatureWindowFrom,
  FlightPolicyDepatureWindowTo,
  OneWayFareRules,
  CombinableFareRules,
  FlightSearchWindows,
  FlightConfigurationRiskEngineFlightThresholdLimit,
  RailConfiguration,
  RailSupplierSettings,
  HotelConfigurationEnableOvernightHotelPrompt,
  HotelConfigurationDisableRecommendedRankings,
  HotelConfigurationIsImperialSystem,
  HotelConfigurationRadiusDefaultRadius,
  HotelConfigurationRadiusCities,
  HotelConfigurationPaymentNarratives,
  HotelConfigurationTags,
  CarConfigurationBillingReferenceEnabled,
  CarConfigurationBillingReferenceMandatory,
  DebtorLimitCountries,
  DebtorBeamerSettingsGroup,
  DebtorBeamerEnabled,
  DebtorAddSegmentsSettingsGroup,
  DebtorAddSegmentsEnabled,
  DebtorGds,
  AuthorisationHoldQueue,
  AutoTicketingQueue,
  Pcc,
  PccCity,
  TeamRejectionQueue,
  NdcSabreQueue,
  NdcQueueEmail,
  PostBookingChangesQueue,
  PostBookingChangesEmail,
  TramadaConfigurationAgencyId,
  TramadaConfigurationDebtorId,
  TramadaConfigurationDebtorAuthCode,
  TramadaConfigurationDatabase,
  CreatedBy,
  CreatedOn,
  ModifiedBy,
  ModifiedOn,
  DebtorOrderNumberCodesItem,
  DebtorTermsAndConditionsItem,
  DebtorApproversItem,
  ItineraryPoliciesItem,
  CompanyReferencesGridItem,
  NDCPNRRemarksGridItem,
  AgencyCreditCardsItem,
  DebtorAgencyReasonCodesItem,
  PaymentConfigurationsItem,
  VirtualCreditCardConfigurationsItem,
  OneWayFareRulesItem,
  CombinableFareRulesItem,
  FlightSearchWindowItem,
  RailSupplierSettingsItem,
  HotelConfigurationRadiusCitiesItem,
  HotelConfigurationPaymentNarrativesItem,
  DebtorGdsItem,
  DebtorOrderNumberCodesCode,
  DebtorOrderNumberCodesTitle,
  TermsAndConditionsCountries,
  TermsAndConditionsSegmentTypes,
  TermsAndConditionsText,
  DebtorApproversFirstName,
  DebtorApproversLastName,
  DebtorApproversEmail,
  DebtorApproversCostCentres,
  DebtorApproversDepartments,
  DebtorApproversTravellers,
  DebtorApproversPolicyCodeTiers,
  DebtorApproversEnabled,
  ItineraryPoliciesCode,
  ItineraryPoliciesTitle,
  ItineraryPoliciesCountries,
  ItineraryPoliciesApprovalLevel,
  ItineraryPoliciesBreakPolicyEscalationApprovalLevel,
  ItineraryPoliciesApprovalTiers,
  ItineraryPoliciesTabs,
  ItineraryPoliciesReasonsForTravel,
  CompanyReferencesCode,
  CompanyReferencesTitle,
  CompanyReferencesOptions,
  CompanyReferencesFlags,
  CompanyReferencesMandatory,
  CompanyReferencesChildren,
  NDCPNRRemarksDisplayName,
  NDCPNRRemarksRemarks,
  AgencyCreditCardsItemTitle,
  AgencyCreditCardsItemId,
  CreditCardId,
  CreditCardProvider,
  SegmentTypes,
  AgencyCreditCardsItemCreatedBy,
  AgencyCreditCardsItemCreatedOn,
  AgencyCreditCardsItemModifiedBy,
  AgencyCreditCardsItemModifiedOn,
  DebtorAgencyReasonCodesCode,
  DebtorAgencyReasonCodesTitle,
  PaymentConfigurationsProvider,
  PaymentConfigurationsPaymentTypes,
  VirtualCreditCardConfigurationsCardPoolId,
  VirtualCreditCardConfigurationsAgentId,
  VirtualCreditCardConfigurationsCardIssuer,
  VirtualCreditCardConfigurationsCardCode,
  VirtualCreditCardConfigurationsCardProvider,
  VirtualCreditCardConfigurationsCardSegmentTypes,
  VirtualCreditCardConfigurationsCardIssuerEnhancedDataMappings,
  VirtualCreditCardConfigurationsCardDisplayName,
  OneWayFareRulesOrigin,
  OneWayFareRulesDestination,
  CombinableFareRulesOrigin,
  CombinableFareRulesDestination,
  FlightSearchWindowsIsAllDaySearch,
  FlightSearchWindowsFlightSearchWindowFrom,
  FlightSearchWindowsFlightSearchWindowTo,
  FlightSearchWindowsFlightPolicyDepartureWindowFrom,
  FlightSearchWindowsFlightPolicyDepartureWindowTo,
  FlightSearchWindowsOrigins,
  FlightSearchWindowsDestinations,
  RailSupplierSettingsName,
  RailSupplierSettingsCode,
  RailSupplierSettingsSettings,
  HotelConfigurationRadiusCitiesCityCode,
  HotelConfigurationRadiusCitiesRadius,
  HotelConfigurationPaymentNarrativesPaymentCode,
  HotelConfigurationPaymentNarrativesPaymentNarrative,
  HotelConfigurationPaymentNarrativesPaymentInstructions,
  HotelConfigurationPaymentNarrativesServiceFeeCode,
  HotelConfigurationPaymentNarrativesProviders,
  HotelConfigurationPaymentNarrativesAggregatorTypes,
  HotelConfigurationPaymentNarrativesIsDomesticOnly,
  DebtorGdsName,
  DebtorGdsEnabled,
  DebtorGdsSettings,
  DebtorGdsMiQuestions,
  DebtorGdsCorporateIdentifiers,
  DebtorApproversTravellersItem,
  DebtorApproversPolicyCodeTiersItem,
  ItineraryPoliciesGeneral,
  ItineraryPoliciesFlight,
  ItineraryPoliciesRail,
  ItineraryPoliciesHotel,
  ItineraryPoliciesCar,
  CompanyReferencesChildrenItem,
  PaymentTypesItem,
  VirtualCreditCardIssuerEnhancedDataMappingsItem,
  DebtorGdsMiQuestionsItem,
  DebtorGdsHotelAggsItem,
  DebtorGdsCorporateIdentifiersItem,
  DebtorApproversTravellersId,
  DebtorApproversTravellersTitle,
  DebtorApproversTravellersEmail,
  DebtorApproversPolicyCodeTiersPolicyCode,
  DebtorApproversPolicyCodeTiersTier,
  ItineraryPoliciesItems,
  TravelIntentQuestions,
  TravelIntentQuestionsChildrenItem,
  TravelIntentQuestionsItem,
  ItineraryPoliciesFlightBenchmarksPolicies,
  ItineraryPoliciesFlightBenchmarksExceptions,
  ItineraryPoliciesFlightPolicies,
  ItineraryPoliciesFlightSettingsExcludedProviders,
  ItineraryPoliciesFlightSettingsExcludedRates,
  ItineraryPoliciesFlightSettingsPolicyType,
  ItineraryPoliciesFlightSettingsRateCodes,
  ItineraryPoliciesFlightPolicyExceptions,
  ItineraryPoliciesFlightPolicyExceptionExcludedCarriers,
  ItineraryPoliciesFlightPolicyExceptionSettings,
  ItineraryPoliciesFlightBreakPolicyRules,
  ItineraryPoliciesRailPolicies,
  ItineraryPoliciesRailPolicyExceptions,
  ItineraryPoliciesRailExcludedSuppliers,
  ItineraryPoliciesHotelPolicies,
  ItineraryPoliciesHotelSettingsPolicyType,
  ItineraryPoliciesHotelSettingsRateCodes,
  ItineraryPoliciesHotelRatePlanCodes,
  ItineraryPoliciesHotelSabreCslRatePlanCodes,
  ItineraryPoliciesHotelSettingsExcludedProviders,
  ItineraryPoliciesHotelSettingsIncludedRates,
  ItineraryPoliciesHotelSettingsExcludedRates,
  ItineraryPoliciesHotelDefaultPolicyBenchmarkPreferredAgainstCheapestPreferred,
  ItineraryPoliciesHotelPolicyExceptions,
  ItineraryPoliciesHotelDefaultPolicyRateMin,
  ItineraryPoliciesHotelDefaultPolicyRateMax,
  ItineraryPoliciesHotelPolicyExceptionSettings,
  ItineraryPoliciesHotelBreakPolicyRules,
  ItineraryPoliciesHotelPoliciesLatLngMap,
  ItineraryPoliciesCarPolicies,
  ItineraryPoliciesCarPolicyExceptions,
  ItineraryPoliciesCarPolicyExceptionSettings,
  ItineraryPoliciesCarPolicyPreferred,
  ItineraryPoliciesCarPolicyRestriction,
  ItineraryPoliciesCarBreakPolicyRules,
  CompanyReferencesChildrenMatch,
  CompanyReferencesChildrenCode,
  CompanyReferencesChildrenTitle,
  CompanyReferencesChildrenOptions,
  CompanyReferencesChildrenFlags,
  CompanyReferencesChildrenMandatory,
  CompanyReferencesChildrenSort,
  PaymentConfigurationsPaymentTypesType,
  PaymentConfigurationsPaymentTypesConfigurations,
  VccIssuerEnhancedDataMappingItemReportKey,
  VccIssuerEnhancedDataMappingItemKey,
  VccIssuerEnhancedDataMappingItemValue,
  DebtorGdsMiQuestionsItemSupplier,
  DebtorGdsMiQuestionsItemQuestions,
  DebtorGdsCorporateIdentifiersItemSupplierCode,
  DebtorGdsCorporateIdentifiersItemCorporateCode,
  DebtorGdsCorporateIdentifiersItemTourCode,
  ItineraryPoliciesItemsItem,
  ItineraryPoliciesFlightBenchmarksPoliciesItem,
  ItineraryPoliciesFlightBenchmarksExceptionsItem,
  ItineraryPoliciesFlightPoliciesItem,
  ItineraryPoliciesFlightPolicyExceptionsItem,
  ItineraryPoliciesFlightPolicyExceptionSettingsItem,
  ItineraryPoliciesFlightBreakPolicyRulesItem,
  ItineraryPoliciesFlightBestFareOfFlightItem,
  ItineraryPoliciesRailPoliciesItem,
  ItineraryPoliciesRailPolicyExceptionsItem,
  ItineraryPoliciesHotelPoliciesItem,
  ItineraryPoliciesHotelPolicyExceptionsItem,
  ItineraryPoliciesHotelPolicyExceptionSettingsItem,
  ItineraryPoliciesHotelBreakPolicyRulesItem,
  ItineraryPoliciesCarPoliciesItem,
  ItineraryPoliciesCarPolicyExceptionsItem,
  ItineraryPoliciesCarPolicyExceptionSettingsItem,
  ItineraryPoliciesCarPolicyPreferredItem,
  ItineraryPoliciesCarPolicyRestrictionItem,
  ItineraryPoliciesCarBreakPolicyRulesItem,
  PaymentTypesConfigurationsItem,
  DebtorGdsMiQuestionsItemQuestionsItem,
  ItineraryPoliciesItemsCode,
  ItineraryPoliciesItemsTitle,
  ItineraryPoliciesFlightBenchmarksPoliciesCarrier,
  ItineraryPoliciesFlightBenchmarksPoliciesBookingCodes,
  ItineraryPoliciesFlightBenchmarksExceptionsCarrier,
  ItineraryPoliciesFlightBenchmarksExceptionsDestinationLocationCode,
  ItineraryPoliciesFlightBenchmarksExceptionsOriginLocationCode,
  ItineraryPoliciesFlightPoliciesCarrier,
  ItineraryPoliciesFlightPoliciesBookingCodes,
  ItineraryPoliciesFlightPoliciesDestinationLocationCode,
  ItineraryPoliciesFlightPoliciesOriginLocationCode,
  ItineraryPoliciesFlightPoliciesOriginCountryCode,
  ItineraryPoliciesFlightPoliciesDestinationCountryCode,
  ItineraryPoliciesFlightPoliciesDurationType,
  ItineraryPoliciesFlightPoliciesDurationFrom,
  ItineraryPoliciesFlightPoliciesDurationTo,
  ItineraryPoliciesFlightPoliciesGroupTypes,
  ItineraryPoliciesFlightPoliciesFareClasses,
  ItineraryPoliciesFlightPoliciesPolicyType,
  ItineraryPoliciesFlightPolicyExceptionsTitle,
  ItineraryPoliciesFlightPolicyExceptionsCode,
  ItineraryPoliciesFlightPolicyExceptionsCountries,
  ItineraryPoliciesFlightPolicyExceptionSettingsOriginCountryCode,
  ItineraryPoliciesFlightPolicyExceptionSettingsDestinationCountryCode,
  ItineraryPoliciesFlightPolicyExceptionSettingsDurationFrom,
  ItineraryPoliciesFlightPolicyExceptionSettingsDurationTo,
  ItineraryPoliciesFlightPolicyExceptionSettingsGroupTypes,
  ItineraryPoliciesFlightPolicyExceptionSettingsPriceTolerance,
  ItineraryPoliciesFlightPolicyExceptionSettingsLowestFareGroupType,
  ItineraryPoliciesFlightPolicyExceptionSettingsFlightType,
  ItineraryPoliciesFlightPolicyExceptionSettingsBenchmarkMostDirect,
  ItineraryPoliciesFlightBreakPolicyRulesOrigins,
  ItineraryPoliciesFlightBreakPolicyRulesDestinations,
  ItineraryPoliciesFlightBreakPolicyRulesBreakPolicyWindow,
  ItineraryPoliciesRailPoliciesSuppliers,
  ItineraryPoliciesRailPoliciesPolicyType,
  ItineraryPoliciesRailPoliciesGroupTypes,
  ItineraryPoliciesRailPolicyExceptionsTitle,
  ItineraryPoliciesRailPolicyExceptionsCode,
  ItineraryPoliciesRailPolicyExceptionsCountries,
  ItineraryPoliciesHotelPoliciesPolicyName,
  ItineraryPoliciesHotelPoliciesHotels,
  ItineraryPoliciesSabreCslPoliciesHotels,
  ItineraryPoliciesHotelPoliciesRateMin,
  ItineraryPoliciesHotelPoliciesRateMax,
  ItineraryPoliciesHotelPoliciesChainCodes,
  ItineraryPoliciesHotelPoliciesLocationCode,
  ItineraryPoliciesHotelPoliciesCountryCode,
  ItineraryPoliciesHotelPoliciesPostCode,
  ItineraryPoliciesHotelPoliciesMinimumHotelRating,
  ItineraryPoliciesHotelPoliciesExcludedChainCodes,
  ItineraryPoliciesHotelPoliciesExcludedHotels,
  ItineraryPoliciesHotelPoliciesRadius,
  ItineraryPoliciesHotelPoliciesLatitude,
  ItineraryPoliciesHotelPoliciesLongitude,
  ItineraryPoliciesHotelPoliciesLatLong,
  ItineraryPoliciesHotelPolicyExceptionsTitle,
  ItineraryPoliciesHotelPolicyExceptionsCode,
  ItineraryPoliciesHotelPolicyExceptionsCountries,
  ItineraryPoliciesHotelPolicyExceptionSettingsName,
  ItineraryPoliciesHotelPolicyExceptionSettingsLocationCode,
  ItineraryPoliciesHotelPolicyExceptionSettingsCountryCode,
  ItineraryPoliciesHotelPolicyExceptionSettingsMaximumDailyRate,
  ItineraryPoliciesHotelPolicyExceptionSettingsRadius,
  ItineraryPoliciesHotelPolicyExceptionSettingsLatitude,
  ItineraryPoliciesHotelPolicyExceptionSettingsLongitude,
  ItineraryPoliciesHotelPolicyExceptionSettingsLatLong,
  ItineraryPoliciesHotelBreakPolicyRulesCountries,
  ItineraryPoliciesHotelBreakPolicyRulesBreakPolicyWindow,
  ItineraryPoliciesCarPoliciesName,
  ItineraryPoliciesCarPoliciesSupplierCode,
  ItineraryPoliciesCarPoliciesSupplierTitle,
  ItineraryPoliciesCarPoliciesCorporateCode,
  ItineraryPoliciesCarPoliciesRate,
  ItineraryPoliciesCarPoliciesDepartments,
  ItineraryPoliciesCarPoliciesCostCentres,
  ItineraryPoliciesCarPoliciesAllowDeliveryAndCollection,
  ItineraryPoliciesCarPoliciesAllowMineSpecVehicles,
  ItineraryPoliciesCarPolicyExceptionsTitle,
  ItineraryPoliciesCarPolicyExceptionsCode,
  ItineraryPoliciesCarPolicyExceptionsCountries,
  ItineraryPoliciesCarPolicyExceptionSettingsMaximumDailyRate,
  ItineraryPoliciesCarPolicyExceptionSettingsLocationCodes,
  ItineraryPoliciesCarPolicyExceptionSettingsCountryCodes,
  ItineraryPoliciesCarPolicyExceptionSettingsSuppliers,
  ItineraryPoliciesCarPolicyExceptionSettingsSipps,
  ItineraryPoliciesCarPolicyPreferredSuppliers,
  ItineraryPoliciesCarPolicyPreferredLocationCodes,
  ItineraryPoliciesCarPolicyPreferredCountryCodes,
  ItineraryPoliciesCarPolicyPreferredSipps,
  ItineraryPoliciesCarPolicyRestrictionSuppliers,
  ItineraryPoliciesCarPolicyRestrictionLocationCodes,
  ItineraryPoliciesCarPolicyRestrictionCountryCodes,
  ItineraryPoliciesCarPolicyRestrictionSipps,
  ItineraryPoliciesCarPolicyRestrictionMaximumDailyRate,
  ItineraryPoliciesCarPolicyRestrictionPolicyType,
  ItineraryPoliciesCarBreakPolicyRulesCountries,
  ItineraryPoliciesCarBreakPolicyRulesBreakPolicyWindow,
  PaymentConfigurationsPaymentTypesConfigurationsSector,
  PaymentConfigurationsPaymentTypesConfigurationsSuppliers,
  DebtorGdsMiQuestionsItemQuestionsItemQuestion,
  DebtorGdsMiQuestionsItemQuestionsItemAnswerFormat,
  PaymentConfigurationsPaymentTypesConfigurationsSuppliersItem,
  PaymentConfigurationsPaymentTypesConfigurationsSuppliersName,
  PaymentConfigurationsPaymentTypesConfigurationsSuppliersSettings,
  DebtorGdsSupplierConfiguration,
  DebtorGdsSupplierConfigurationsGridItem,
  DebtorGdsSupplierConfigurationSupplierCode,
  DebtorGdsSupplierConfigurationSettings,
  DebtorGdsSupplierConfigurationCountryPairs,
  DebtorGdsSupplierConfigurationCountryPairGridItem,
  DebtorGdsSupplierConfigurationCountryPairOrigins,
  DebtorGdsSupplierConfigurationCountryPairDestinations,
  DebtorGdsSupplierConfigurationCountryPairType,
  DebtorAgencyChangeFees,
  DebtorAgencyChangeFeesItem,
  DebtorAgencyChangeFeesName,
  DebtorAgencyChangeFeesAmount,
  DebtorAgencyChangeFeesCountries,
  DebtorAgencyChangeFeesServiceFeeCode,
  ReasonsForChanges,
  ReasonForChangeItem,
  ReasonForChangeTitle,
  ReasonForChangeCode,
  HotelRateToleranceEnabled,
  HotelRateToleranceMin,
  HotelRateToleranceMax,
  AgencyServiceFeeRemarks,
  CancellationRemarks,
  SegmentCancellationRemarks,
  AgencyServiceFeeRemarksItem,
  AgencyServiceFeeRemarkSegmentTypes,
  AgencyServiceFeeRemarkCountries,
  AgencyServiceFeeRemarkValue,
  AgencyServiceFeeRemarkTitle,
  DebtorProductType,
  DebtorProductsItem,
  DebtorProducts,
  DebtorProductCTMMobileSettings,
  DebtorProductMobileSetting1,
  DebtorProductMobileSetting2,
  DebtorProductMobileSetting3,
  DebtorProductLightningSettings,
  DebtorProductCTMPortalSettings,
  DebtorProductCTMApproveSettings,
  DebtorProductHotelReviewSettings,
  DebtorProductRideShareSettings,
  DebtorProductRiskSettings,
  DebtorProductRiskSetting5Item,
  SeletedProfilesForUserCreationItem,
  ClientIpAddressItem,
  DebtorProductHotelReviewSetting4Item
}



// WEBPACK FOOTER //
// ./src/config/fields/debtors.js